function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebTour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2475 1650",
    style: {
      enableBackground: "new 0 0 2475 1650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 2475,
    height: 1650
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.0812,
    y1: 1752.0598,
    x2: 2281.3005,
    y2: 129.5907,
    gradientTransform: "matrix(1.0299 -0.0127 0.012 0.972 -52.0687 80.7422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5fae5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e5f0d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2306.682,725.959c-59.979-83.216-185.459-126.651-190.256-252.414 c-3.117-81.721,32.711-126.474-26.358-195.535c-142.788-166.938-359.867-184.03-544.143-111.282 c-184.214,72.724-330.38,215.748-536.26,209.777c-112.119-3.252-216.903-56.215-327.955-65.026 c-34.211-2.714-66.108,0.369-95.87,8.539C474.271,350.647,376.797,461.69,341.087,584.16 c-28.947,99.279,10.801,196.442-35.372,293.881C256.5,981.898,157.956,1054.83,134.376,1174.323 c-28.301,143.417,88.107,266.396,211.55,268.764c78.574,1.507,224.003-13.088,290.118-63.344 c80.503-61.193,160.306-66.137,255.05-65c180.307,2.165,361.063,41.314,539.354,68.577 c152.773,23.361,303.504,58.886,458.079,61.725c113.519,2.085,209.838,2.465,269.69-124.013 C2229.752,1169.861,2432.485,900.504,2306.682,725.959z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M2024.297,942.09c-0.368,0-0.738-0.115-1.055-0.354c-0.771-0.583-0.925-1.682-0.341-2.455 c1.417-1.873,2.888-3.743,4.371-5.557c0.611-0.751,1.716-0.857,2.464-0.248c0.749,0.612,0.86,1.716,0.247,2.465 c-1.454,1.779-2.897,3.615-4.287,5.454C2025.351,941.85,2024.827,942.09,2024.297,942.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M2351.712,1017.075c-0.819,0-1.55-0.576-1.717-1.41c-0.926-4.645-2.048-9.312-3.337-13.867 c-0.263-0.932,0.278-1.899,1.209-2.162c0.927-0.275,1.899,0.277,2.162,1.208c1.314,4.646,2.458,9.402,3.402,14.138 c0.189,0.949-0.428,1.871-1.376,2.06C2351.941,1017.064,2351.825,1017.075,2351.712,1017.075z M2340.554,981.018 c-0.681,0-1.328-0.399-1.612-1.064c-1.854-4.344-3.911-8.68-6.112-12.889c-0.448-0.859-0.116-1.916,0.741-2.364 c0.857-0.452,1.915-0.116,2.364,0.739c2.242,4.291,4.339,8.711,6.229,13.138c0.38,0.89-0.034,1.919-0.924,2.299 C2341.017,980.973,2340.783,981.018,2340.554,981.018z M2322.264,947.995c-0.555,0-1.1-0.262-1.44-0.753 c-2.707-3.899-5.596-7.731-8.584-11.39c-0.613-0.749-0.5-1.853,0.249-2.465c0.748-0.611,1.851-0.503,2.464,0.248 c3.047,3.731,5.99,7.637,8.749,11.609c0.552,0.794,0.355,1.885-0.44,2.438C2322.957,947.894,2322.609,947.995,2322.264,947.995z  M2044.562,919.463c-0.464,0-0.929-0.185-1.274-0.549c-0.664-0.703-0.633-1.812,0.07-2.475c3.504-3.31,7.187-6.528,10.948-9.565 c0.751-0.609,1.855-0.491,2.464,0.263c0.607,0.753,0.489,1.856-0.263,2.464c-3.69,2.978-7.304,6.136-10.741,9.383 C2045.427,919.304,2044.994,919.463,2044.562,919.463z M2297.681,919.361c-0.433,0-0.866-0.159-1.205-0.481 c-3.433-3.254-7.042-6.412-10.724-9.385c-0.753-0.609-0.87-1.711-0.262-2.463c0.607-0.753,1.711-0.869,2.463-0.263 c3.754,3.033,7.432,6.253,10.932,9.57c0.702,0.665,0.732,1.774,0.067,2.475C2298.608,919.178,2298.145,919.361,2297.681,919.361 z M2074.508,896.474c-0.588,0-1.161-0.294-1.493-0.831c-0.508-0.823-0.252-1.902,0.571-2.411 c4.119-2.544,8.377-4.951,12.655-7.156c0.86-0.445,1.917-0.106,2.359,0.754c0.444,0.861,0.106,1.916-0.754,2.359 c-4.198,2.164-8.377,4.527-12.419,7.023C2075.14,896.391,2074.822,896.474,2074.508,896.474z M2267.757,896.382 c-0.313,0-0.63-0.084-0.917-0.26c-4.018-2.474-8.198-4.826-12.426-6.992c-0.86-0.44-1.201-1.495-0.76-2.357 c0.441-0.861,1.497-1.201,2.358-0.76c4.309,2.205,8.57,4.604,12.666,7.125c0.824,0.508,1.08,1.586,0.573,2.41 C2268.919,896.086,2268.345,896.382,2267.757,896.382z M2108.477,880.012c-0.716,0-1.388-0.441-1.646-1.153 c-0.33-0.91,0.139-1.914,1.049-2.246c4.54-1.647,9.2-3.136,13.852-4.42c0.932-0.257,1.896,0.287,2.155,1.221 c0.258,0.932-0.289,1.897-1.222,2.155c-4.562,1.261-9.134,2.72-13.588,4.337 C2108.877,879.978,2108.675,880.012,2108.477,880.012z M2233.759,880.008c-0.198,0-0.398-0.032-0.594-0.104 c-4.452-1.605-9.025-3.057-13.594-4.315c-0.933-0.256-1.481-1.22-1.225-2.154c0.257-0.932,1.221-1.48,2.154-1.223 c4.656,1.28,9.316,2.759,13.854,4.397c0.91,0.328,1.381,1.331,1.053,2.241C2235.149,879.565,2234.477,880.008,2233.759,880.008z  M2197.141,870.887c-0.083,0-0.167-0.005-0.252-0.017c-4.68-0.672-9.454-1.165-14.188-1.47 c-0.966-0.062-1.698-0.895-1.636-1.861c0.063-0.965,0.909-1.671,1.86-1.635c4.825,0.31,9.69,0.814,14.462,1.497 c0.957,0.139,1.623,1.025,1.485,1.983C2198.747,870.257,2197.998,870.887,2197.141,870.887z M2145.094,870.858 c-0.858,0-1.607-0.631-1.732-1.505c-0.136-0.956,0.529-1.844,1.488-1.981c4.78-0.681,9.646-1.18,14.462-1.483 c0.98-0.017,1.798,0.674,1.859,1.639c0.061,0.965-0.672,1.796-1.638,1.858c-4.726,0.298-9.5,0.787-14.189,1.456 C2145.26,870.853,2145.177,870.858,2145.094,870.858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M2355.162,1047.331c-0.943,0-1.721-0.749-1.75-1.699c-0.07-2.298-0.186-4.628-0.343-6.927 c-0.067-0.965,0.662-1.801,1.628-1.868c0.961-0.021,1.802,0.664,1.867,1.629c0.161,2.342,0.279,4.718,0.35,7.06 c0.029,0.967-0.73,1.774-1.698,1.805C2355.198,1047.331,2355.18,1047.331,2355.162,1047.331z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M2303.348,1181.249c-0.44,0-0.88-0.164-1.221-0.494c-0.694-0.674-0.71-1.784-0.036-2.477 c1.615-1.663,3.208-3.369,4.737-5.071c0.646-0.715,1.754-0.775,2.474-0.132c0.719,0.647,0.779,1.755,0.132,2.476 c-1.558,1.733-3.183,3.471-4.829,5.166C2304.261,1181.071,2303.805,1181.249,2303.348,1181.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M2171.342,1237.185l-1.587-0.007c-0.968-0.01-1.744-0.802-1.735-1.769 c0.01-0.961,0.792-1.735,1.752-1.735c0.005,0,0.011,0,0.017,0l1.552,0.007c4.137,0,8.335-0.144,12.476-0.428 c0.97-0.021,1.801,0.664,1.867,1.629c0.066,0.965-0.663,1.802-1.628,1.868 C2179.837,1237.038,2175.559,1237.185,2171.342,1237.185z M2146.819,1235.548c-0.078,0-0.157-0.005-0.235-0.016 c-4.703-0.631-9.444-1.452-14.093-2.441c-0.946-0.202-1.55-1.133-1.348-2.078c0.202-0.948,1.128-1.541,2.078-1.35 c4.561,0.972,9.214,1.779,13.828,2.397c0.958,0.128,1.632,1.011,1.503,1.969 C2148.435,1234.908,2147.683,1235.548,2146.819,1235.548z M2206.754,1233.74c-0.82,0-1.552-0.578-1.717-1.413 c-0.187-0.95,0.431-1.872,1.381-2.058c4.577-0.9,9.171-1.991,13.655-3.24c0.93-0.265,1.897,0.284,2.158,1.216 c0.26,0.932-0.285,1.897-1.217,2.157c-4.57,1.275-9.253,2.387-13.92,3.305C2206.979,1233.729,2206.865,1233.74,2206.754,1233.74 z M2110.686,1226.95c-0.191,0-0.385-0.031-0.575-0.097c-4.496-1.56-8.977-3.312-13.321-5.206 c-0.886-0.387-1.292-1.42-0.905-2.306c0.385-0.888,1.417-1.295,2.305-0.907c4.261,1.858,8.659,3.577,13.07,5.11 c0.913,0.317,1.397,1.316,1.08,2.229C2112.09,1226.496,2111.412,1226.95,2110.686,1226.95z M2242.284,1222.9 c-0.684,0-1.334-0.404-1.616-1.074c-0.374-0.891,0.045-1.918,0.937-2.292c4.279-1.796,8.558-3.791,12.721-5.931 c0.859-0.443,1.918-0.103,2.359,0.758c0.442,0.861,0.103,1.916-0.758,2.359c-4.242,2.179-8.605,4.214-12.966,6.044 C2242.74,1222.858,2242.51,1222.9,2242.284,1222.9z M2077.008,1211.3c-0.304,0-0.613-0.079-0.893-0.246 c-4.078-2.422-8.115-5.038-12.001-7.774c-0.791-0.556-0.981-1.649-0.424-2.439c0.558-0.794,1.649-0.982,2.441-0.424 c3.813,2.682,7.774,5.248,11.773,7.627c0.832,0.494,1.105,1.569,0.612,2.4C2078.188,1210.994,2077.606,1211.3,2077.008,1211.3z  M2274.913,1205.143c-0.56,0-1.11-0.267-1.449-0.765c-0.545-0.799-0.339-1.89,0.46-2.434c3.852-2.626,7.65-5.433,11.289-8.342 c0.757-0.604,1.857-0.481,2.462,0.275c0.604,0.755,0.481,1.858-0.274,2.462c-3.708,2.963-7.579,5.823-11.503,8.499 C2275.596,1205.044,2275.252,1205.143,2274.913,1205.143z M2047.178,1189.194c-0.421,0-0.844-0.151-1.18-0.458 c-3.499-3.191-6.926-6.569-10.185-10.04c-0.662-0.705-0.627-1.813,0.078-2.476c0.704-0.662,1.813-0.631,2.476,0.077 c3.197,3.406,6.56,6.72,9.991,9.852c0.715,0.652,0.766,1.759,0.114,2.474 C2048.127,1189.002,2047.653,1189.194,2047.178,1189.194z M2022.422,1161.516c-0.541,0-1.075-0.25-1.418-0.722 c-2.197-3.02-4.337-6.154-6.36-9.317c-0.545-0.852-1.082-1.707-1.611-2.563c-0.508-0.824-0.252-1.904,0.571-2.41 c0.822-0.51,1.901-0.252,2.41,0.57c0.518,0.842,1.045,1.68,1.58,2.515c1.986,3.105,4.086,6.181,6.242,9.146 c0.57,0.782,0.396,1.877-0.386,2.446C2023.139,1161.406,2022.778,1161.516,2022.422,1161.516z M2003.668,1129.451 c-0.665,0-1.299-0.38-1.594-1.023c-1.975-4.32-3.806-8.771-5.443-13.231c-0.333-0.909,0.133-1.916,1.042-2.248 c0.906-0.337,1.913,0.133,2.248,1.04c1.605,4.376,3.402,8.744,5.34,12.981c0.402,0.879,0.015,1.919-0.865,2.322 C2004.16,1129.4,2003.912,1129.451,2003.668,1129.451z M1991.724,1094.28c-0.798,0-1.52-0.549-1.706-1.36 c-1.062-4.626-1.955-9.356-2.657-14.059c-0.142-0.956,0.517-1.848,1.475-1.991c0.944-0.142,1.849,0.517,1.991,1.475 c0.688,4.614,1.565,9.255,2.605,13.792c0.216,0.943-0.373,1.883-1.316,2.099 C1991.986,1094.266,1991.854,1094.28,1991.724,1094.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M1987.133,1057.352c-0.949,0-1.73-0.76-1.75-1.713c-0.052-2.333-0.06-4.711-0.023-7.07 c0.015-0.968,0.818-1.702,1.779-1.724c0.968,0.016,1.74,0.813,1.724,1.779c-0.037,2.315-0.029,4.648,0.021,6.937 c0.022,0.968-0.744,1.769-1.712,1.791C1987.16,1057.352,1987.147,1057.352,1987.133,1057.352z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M2031.183,1031.432c-0.231,0.913,0.142,1.874,0.93,2.39l22.486,14.74 c-0.228,12.555,1.544,25.235,5.451,37.553l-17.342,20.524c-0.609,0.72-0.693,1.746-0.211,2.556l16.503,27.708 c0.483,0.81,1.426,1.224,2.348,1.032l26.307-5.473c8.97,9.301,19.276,16.899,30.423,22.678l2.252,26.793 c0.079,0.939,0.745,1.725,1.658,1.956l31.262,7.923c0.914,0.232,1.874-0.142,2.39-0.93l14.741-22.486 c12.554,0.228,25.235-1.545,37.552-5.451l20.524,17.342c0.72,0.608,1.746,0.693,2.556,0.211l27.708-16.504 c0.81-0.482,1.224-1.425,1.032-2.348l-5.473-26.307c9.302-8.97,16.9-19.275,22.678-30.423l26.793-2.251 c0.939-0.079,1.725-0.745,1.956-1.659l7.923-31.262c0.232-0.914-0.142-1.873-0.93-2.39l-22.486-14.741 c0.229-12.554-1.544-25.235-5.451-37.552l17.342-20.524c0.608-0.72,0.693-1.746,0.211-2.556l-16.504-27.709 c-0.482-0.81-1.425-1.224-2.348-1.032l-26.306,5.473c-8.97-9.301-19.276-16.9-30.423-22.679l-2.252-26.792 c-0.078-0.939-0.745-1.725-1.658-1.957l-31.262-7.923c-0.914-0.231-1.874,0.142-2.391,0.93l-14.74,22.486 c-12.554-0.228-25.235,1.545-37.552,5.451l-20.525-17.342c-0.719-0.608-1.746-0.693-2.556-0.21l-27.708,16.503 c-0.809,0.482-1.224,1.425-1.032,2.348l5.473,26.306c-9.301,8.97-16.899,19.276-22.678,30.423l-26.792,2.252 c-0.939,0.079-1.725,0.745-1.957,1.659L2031.183,1031.432z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M2172.408,1081.854c-0.01,0-0.02,0-0.03,0c-8.351-0.009-16.199-3.268-22.098-9.178 c-5.899-5.911-9.145-13.765-9.136-22.115c0.008-8.352,3.267-16.201,9.178-22.099c12.201-12.18,32.037-12.16,44.214,0.041 c5.899,5.911,9.145,13.765,9.136,22.115c-0.008,8.352-3.267,16.201-9.178,22.099 C2188.591,1078.608,2180.748,1081.854,2172.408,1081.854z M2172.407,1024.579c-6.938,0-13.462,2.7-18.373,7.601 c-4.918,4.908-7.629,11.436-7.635,18.384c-0.007,6.947,2.693,13.482,7.6,18.399c4.908,4.917,11.437,7.628,18.385,7.635 c0.008,0,0.017,0,0.025,0c6.939,0,13.462-2.7,18.373-7.601c4.917-4.908,7.629-11.436,7.635-18.384 c0.007-6.947-2.693-13.482-7.6-18.399c-4.908-4.917-11.437-7.628-18.385-7.635 C2172.424,1024.579,2172.415,1024.579,2172.407,1024.579z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M2173.217,1131.131c-27.442,0.002-54.216-14.023-69.25-39.263 c-2.936-4.93-5.347-10.165-7.162-15.557l4.98-1.676c1.698,5.04,3.951,9.934,6.697,14.545 c16.669,27.984,48.787,41.224,79.057,35.316c0.057-0.01,0.113-0.022,0.169-0.032c0.059-0.012,0.115-0.022,0.174-0.034 c8.144-1.627,16.148-4.641,23.679-9.127c17.255-10.276,29.476-26.658,34.411-46.127c1.564-6.171,2.336-12.417,2.335-18.62 c-0.003-13.371-3.601-26.544-10.621-38.331c-21.218-35.621-67.458-47.341-103.079-26.125 c-11.712,6.976-21.298,16.974-27.718,28.911l-4.627-2.491c6.87-12.774,17.126-23.471,29.656-30.937 c38.109-22.695,87.583-10.16,110.283,27.952c7.512,12.611,11.361,26.704,11.364,41.01c0.001,6.638-0.825,13.32-2.499,19.92 c-5.279,20.83-18.354,38.358-36.815,49.353C2201.38,1127.484,2187.21,1131.131,2173.217,1131.131z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M284.066,305.322c-0.434,0-0.871-0.135-1.245-0.418c-0.911-0.689-1.091-1.985-0.403-2.897 c1.673-2.211,3.408-4.418,5.159-6.559c0.721-0.886,2.025-1.012,2.909-0.293c0.884,0.723,1.015,2.025,0.292,2.91 c-1.716,2.1-3.42,4.267-5.06,6.437C285.311,305.039,284.692,305.322,284.066,305.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M670.529,393.83c-0.966,0-1.829-0.68-2.026-1.664c-1.092-5.482-2.417-10.991-3.938-16.368 c-0.311-1.101,0.328-2.241,1.428-2.552c1.094-0.325,2.241,0.327,2.552,1.425c1.551,5.484,2.902,11.098,4.015,16.687 c0.223,1.12-0.505,2.209-1.625,2.431C670.799,393.818,670.663,393.83,670.529,393.83z M657.359,351.27 c-0.804,0-1.567-0.471-1.903-1.256c-2.189-5.127-4.616-10.246-7.214-15.213c-0.529-1.014-0.137-2.261,0.874-2.791 c1.012-0.533,2.26-0.137,2.791,0.872c2.647,5.064,5.122,10.282,7.353,15.508c0.448,1.05-0.04,2.266-1.09,2.714 C657.905,351.217,657.629,351.27,657.359,351.27z M635.771,312.292c-0.655,0-1.299-0.309-1.7-0.889 c-3.195-4.602-6.605-9.125-10.133-13.444c-0.723-0.884-0.591-2.187,0.294-2.91c0.883-0.721,2.185-0.594,2.909,0.293 c3.596,4.404,7.071,9.014,10.327,13.703c0.651,0.937,0.419,2.225-0.519,2.878C636.589,312.173,636.178,312.292,635.771,312.292z  M307.986,278.615c-0.548,0-1.096-0.218-1.503-0.648c-0.784-0.83-0.747-2.138,0.083-2.922c4.135-3.907,8.483-7.706,12.922-11.29 c0.887-0.719,2.19-0.579,2.908,0.311c0.717,0.888,0.577,2.191-0.311,2.908c-4.355,3.516-8.621,7.243-12.678,11.076 C309.007,278.427,308.496,278.615,307.986,278.615z M606.754,278.494c-0.511,0-1.023-0.188-1.423-0.567 c-4.052-3.841-8.311-7.568-12.658-11.078c-0.889-0.719-1.027-2.019-0.309-2.908c0.717-0.888,2.02-1.026,2.908-0.311 c4.431,3.58,8.773,7.38,12.904,11.296c0.829,0.786,0.864,2.094,0.079,2.922C607.849,278.278,607.301,278.494,606.754,278.494z  M343.332,251.48c-0.694,0-1.37-0.347-1.762-0.981c-0.6-0.971-0.298-2.245,0.673-2.845c4.862-3.003,9.888-5.844,14.938-8.446 c1.015-0.525,2.263-0.125,2.785,0.89c0.524,1.016,0.125,2.262-0.89,2.785c-4.955,2.555-9.887,5.343-14.659,8.289 C344.078,251.381,343.703,251.48,343.332,251.48z M571.433,251.371c-0.37,0-0.744-0.099-1.082-0.307 c-4.742-2.92-9.676-5.696-14.667-8.253c-1.016-0.519-1.417-1.765-0.898-2.783c0.521-1.016,1.767-1.417,2.784-0.897 c5.086,2.603,10.116,5.434,14.95,8.41c0.972,0.6,1.275,1.872,0.677,2.845C572.805,251.021,572.128,251.371,571.433,251.371z  M383.428,232.049c-0.845,0-1.639-0.521-1.943-1.361c-0.39-1.074,0.164-2.26,1.238-2.651c5.359-1.945,10.859-3.701,16.35-5.218 c1.1-0.303,2.238,0.339,2.543,1.442c0.304,1.1-0.341,2.239-1.443,2.544c-5.384,1.488-10.781,3.211-16.039,5.119 C383.9,232.008,383.662,232.049,383.428,232.049z M531.304,232.045c-0.233,0-0.469-0.038-0.702-0.123 c-5.255-1.894-10.653-3.608-16.045-5.093c-1.101-0.303-1.749-1.439-1.446-2.542c0.303-1.1,1.442-1.747,2.542-1.444 c5.495,1.51,10.997,3.257,16.352,5.19c1.074,0.388,1.63,1.571,1.243,2.645C532.945,231.522,532.152,232.045,531.304,232.045z  M488.082,221.278c-0.098,0-0.197-0.006-0.297-0.02c-5.525-0.794-11.159-1.375-16.747-1.735 c-1.14-0.073-2.004-1.056-1.932-2.197c0.074-1.139,1.073-1.973,2.196-1.93c5.695,0.366,11.438,0.961,17.07,1.767 c1.13,0.163,1.915,1.21,1.753,2.34C489.978,220.535,489.094,221.278,488.082,221.278z M426.649,221.244 c-1.013,0-1.897-0.745-2.044-1.777c-0.161-1.129,0.625-2.177,1.756-2.338c5.642-0.803,11.385-1.393,17.071-1.751 c1.157-0.02,2.122,0.795,2.194,1.934c0.072,1.139-0.794,2.12-1.934,2.193c-5.578,0.352-11.213,0.929-16.748,1.719 C426.845,221.237,426.747,221.244,426.649,221.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M674.601,429.543c-1.113,0-2.032-0.885-2.066-2.005c-0.083-2.712-0.219-5.462-0.405-8.176 c-0.079-1.139,0.782-2.126,1.921-2.205c1.134-0.024,2.126,0.783,2.204,1.922c0.19,2.764,0.329,5.569,0.413,8.334 c0.034,1.141-0.862,2.094-2.004,2.13C674.644,429.543,674.622,429.543,674.601,429.543z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M613.443,587.612c-0.519,0-1.039-0.194-1.441-0.583c-0.819-0.796-0.838-2.106-0.042-2.924 c1.906-1.963,3.787-3.976,5.591-5.985c0.762-0.844,2.071-0.915,2.92-0.156c0.849,0.763,0.919,2.072,0.156,2.922 c-1.839,2.046-3.757,4.097-5.7,6.098C614.521,587.402,613.982,587.612,613.443,587.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M457.631,653.636l-1.873-0.008c-1.142-0.012-2.059-0.947-2.048-2.088 c0.011-1.135,0.935-2.047,2.068-2.047c0.006,0,0.013,0,0.02,0l1.832,0.008c4.884,0,9.838-0.169,14.725-0.505 c1.145-0.024,2.126,0.783,2.204,1.922c0.078,1.139-0.782,2.126-1.921,2.205C467.657,653.462,462.608,653.636,457.631,653.636z  M428.685,651.703c-0.092,0-0.185-0.006-0.278-0.018c-5.551-0.745-11.147-1.714-16.635-2.881 c-1.117-0.238-1.83-1.337-1.591-2.453c0.238-1.119,1.332-1.819,2.453-1.593c5.383,1.147,10.876,2.1,16.322,2.829 c1.132,0.152,1.926,1.194,1.775,2.324C430.592,650.948,429.704,651.703,428.685,651.703z M499.428,649.569 c-0.968,0-1.832-0.683-2.026-1.668c-0.221-1.121,0.509-2.209,1.629-2.429c5.403-1.062,10.825-2.351,16.118-3.825 c1.098-0.313,2.239,0.335,2.547,1.436c0.307,1.1-0.336,2.239-1.437,2.546c-5.395,1.504-10.922,2.817-16.431,3.901 C499.695,649.557,499.56,649.569,499.428,649.569z M386.036,641.555c-0.225,0-0.454-0.036-0.678-0.115 c-5.307-1.842-10.596-3.909-15.723-6.145c-1.046-0.456-1.525-1.676-1.068-2.722c0.454-1.048,1.672-1.529,2.721-1.07 c5.03,2.193,10.22,4.222,15.427,6.032c1.078,0.374,1.65,1.553,1.275,2.631C387.693,641.019,386.892,641.555,386.036,641.555z  M541.366,636.775c-0.808,0-1.575-0.477-1.907-1.268c-0.442-1.052,0.052-2.263,1.106-2.706c5.05-2.12,10.102-4.475,15.015-7.001 c1.014-0.523,2.264-0.121,2.785,0.895c0.522,1.016,0.121,2.262-0.895,2.785c-5.008,2.572-10.157,4.974-15.304,7.134 C541.905,636.725,541.633,636.775,541.366,636.775z M346.284,623.083c-0.359,0-0.723-0.093-1.054-0.291 c-4.813-2.859-9.579-5.947-14.165-9.175c-0.934-0.656-1.158-1.947-0.501-2.88c0.658-0.937,1.947-1.159,2.881-0.501 c4.5,3.166,9.176,6.195,13.897,9.002c0.982,0.584,1.304,1.852,0.722,2.833C347.677,622.721,346.989,623.083,346.284,623.083z  M579.88,615.815c-0.661,0-1.311-0.315-1.71-0.902c-0.643-0.943-0.4-2.231,0.543-2.874c4.547-3.1,9.03-6.413,13.325-9.846 c0.893-0.713,2.192-0.567,2.907,0.325c0.713,0.891,0.567,2.193-0.324,2.906c-4.377,3.497-8.945,6.874-13.578,10.032 C580.686,615.698,580.281,615.815,579.88,615.815z M311.074,596.99c-0.497,0-0.996-0.178-1.392-0.541 c-4.13-3.766-8.175-7.754-12.022-11.851c-0.781-0.832-0.74-2.14,0.092-2.922c0.831-0.781,2.141-0.745,2.923,0.091 c3.774,4.02,7.743,7.932,11.793,11.629c0.844,0.769,0.904,2.076,0.134,2.92C312.194,596.763,311.635,596.99,311.074,596.99z  M281.853,564.32c-0.639,0-1.269-0.295-1.674-0.852c-2.593-3.564-5.119-7.263-7.507-10.997 c-0.643-1.006-1.277-2.015-1.901-3.025c-0.6-0.973-0.298-2.247,0.674-2.845c0.97-0.602,2.244-0.297,2.845,0.672 c0.612,0.993,1.234,1.983,1.865,2.968c2.344,3.665,4.823,7.296,7.367,10.795c0.672,0.923,0.467,2.215-0.455,2.888 C282.7,564.191,282.274,564.32,281.853,564.32z M259.718,526.473c-0.784,0-1.534-0.448-1.882-1.208 c-2.331-5.099-4.493-10.353-6.424-15.617c-0.393-1.072,0.158-2.262,1.23-2.653c1.069-0.398,2.259,0.157,2.653,1.228 c1.894,5.165,4.015,10.32,6.303,15.322c0.474,1.038,0.017,2.266-1.021,2.74C260.298,526.412,260.006,526.473,259.718,526.473z  M245.619,484.959c-0.942,0-1.794-0.648-2.013-1.605c-1.253-5.46-2.308-11.043-3.136-16.594 c-0.168-1.129,0.611-2.181,1.741-2.35c1.115-0.168,2.182,0.61,2.35,1.741c0.812,5.446,1.847,10.924,3.075,16.279 c0.256,1.113-0.44,2.223-1.553,2.478C245.928,484.943,245.773,484.959,245.619,484.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M240.201,441.371c-1.121,0-2.042-0.897-2.066-2.021c-0.062-2.754-0.071-5.561-0.027-8.346 c0.018-1.143,0.965-2.009,2.1-2.035c1.142,0.018,2.054,0.959,2.035,2.1c-0.043,2.732-0.034,5.486,0.025,8.188 c0.026,1.143-0.878,2.088-2.02,2.114C240.232,441.371,240.217,441.371,240.201,441.371z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M292.195,410.776c-0.273,1.078,0.168,2.211,1.098,2.821l26.541,17.399 c-0.269,14.819,1.823,29.786,6.434,44.325l-20.469,24.225c-0.718,0.849-0.818,2.061-0.249,3.017l19.479,32.705 c0.57,0.956,1.683,1.445,2.771,1.219l31.051-6.46c10.588,10.978,22.752,19.947,35.91,26.768l2.658,31.625 c0.094,1.108,0.879,2.036,1.958,2.309l36.9,9.352c1.079,0.273,2.212-0.168,2.821-1.098l17.399-26.541 c14.818,0.269,29.786-1.823,44.324-6.434l24.226,20.47c0.85,0.718,2.061,0.818,3.017,0.249l32.705-19.48 c0.956-0.569,1.445-1.682,1.219-2.771l-6.46-31.051c10.979-10.588,19.948-22.752,26.768-35.91l31.625-2.657 c1.108-0.093,2.035-0.88,2.309-1.958l9.352-36.9c0.274-1.079-0.168-2.211-1.098-2.821l-26.541-17.399 c0.27-14.818-1.823-29.786-6.433-44.325l20.47-24.226c0.717-0.849,0.818-2.061,0.249-3.017l-19.48-32.706 c-0.569-0.956-1.682-1.445-2.771-1.218l-31.051,6.46c-10.588-10.979-22.752-19.948-35.91-26.769l-2.658-31.624 c-0.092-1.109-0.88-2.036-1.958-2.309l-36.9-9.352c-1.078-0.273-2.211,0.167-2.821,1.098l-17.399,26.541 c-14.818-0.269-29.786,1.823-44.325,6.434l-24.226-20.47c-0.849-0.718-2.061-0.818-3.016-0.248l-32.705,19.479 c-0.956,0.569-1.445,1.682-1.219,2.771l6.46,31.051c-10.978,10.588-19.947,22.752-26.768,35.91l-31.624,2.658 c-1.109,0.093-2.036,0.879-2.309,1.958L292.195,410.776z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M458.889,470.291c-0.012,0-0.023,0-0.035,0c-9.857-0.01-19.12-3.857-26.084-10.833 c-6.964-6.977-10.794-16.247-10.784-26.103c0.009-9.858,3.857-19.122,10.833-26.085c14.401-14.377,37.815-14.353,52.188,0.048 c6.963,6.977,10.794,16.247,10.784,26.103c-0.009,9.858-3.857,19.123-10.833,26.085 C477.99,466.461,468.733,470.291,458.889,470.291z M458.888,402.688c-8.19,0-15.889,3.187-21.687,8.972 c-5.805,5.793-9.005,13.499-9.012,21.699c-0.008,8.2,3.178,15.914,8.97,21.717c5.793,5.803,13.5,9.004,21.7,9.012 c0.009,0,0.02,0,0.029,0c8.19,0,15.89-3.186,21.687-8.972c5.804-5.793,9.005-13.499,9.012-21.699 c0.008-8.2-3.178-15.914-8.971-21.717c-5.793-5.803-13.5-9.004-21.7-9.012C458.908,402.688,458.897,402.688,458.888,402.688z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M459.844,528.456c-32.391,0.002-63.993-16.552-81.738-46.344 c-3.466-5.82-6.311-11.999-8.454-18.363l5.878-1.979c2.004,5.949,4.663,11.726,7.904,17.168 c19.675,33.031,57.585,48.658,93.314,41.686c0.067-0.012,0.133-0.026,0.2-0.039c0.07-0.014,0.135-0.026,0.205-0.04 c9.613-1.92,19.06-5.478,27.95-10.773c20.367-12.13,34.792-31.466,40.616-54.445c1.846-7.283,2.757-14.656,2.756-21.978 c-0.003-15.782-4.251-31.331-12.537-45.244c-25.044-42.045-79.623-55.879-121.668-30.836 c-13.825,8.234-25.139,20.035-32.717,34.125l-5.462-2.94c8.109-15.078,20.215-27.704,35.005-36.516 c44.982-26.788,103.379-11.992,130.172,32.993c8.866,14.886,13.41,31.521,13.413,48.406c0.001,7.835-0.974,15.722-2.949,23.512 c-6.231,24.586-21.664,45.276-43.455,58.254C493.086,524.151,476.36,528.456,459.844,528.456z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M215.743,519.805c0.734-6.327,9.48-7.467,11.786-1.53c22.286,57.399,85.439,206.078,167.6,280.251 c133.778,120.77,235.139,328.133,168.517,447.104C563.646,1245.63,135.797,1209.118,215.743,519.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.43,
      fill: "#FFFFFF"
    },
    d: "M237.133,602.736c0.322,1.555,0.796,3.234,1.214,4.865l1.355,4.911l2.819,9.796 c1.917,6.521,3.903,13.022,5.907,19.518c4.046,12.979,8.253,25.909,12.579,38.797c8.629,25.784,17.766,51.397,27.388,76.825 c19.319,50.821,40.333,101.013,63.818,150.04c2.86,6.164,5.953,12.215,8.934,18.32l4.496,9.146 c1.496,3.05,3.082,6.054,4.619,9.083c3.112,6.039,6.159,12.113,9.325,18.123l9.627,17.964l2.417,4.486l2.497,4.441l4.993,8.883 l4.993,8.883c1.687,2.948,3.445,5.854,5.164,8.783c3.477,5.835,6.867,11.723,10.416,17.514l10.762,17.304 c0.901,1.439,1.776,2.896,2.698,4.322l2.794,4.259l5.588,8.519l5.588,8.52c1.898,2.816,3.87,5.581,5.801,8.374l5.823,8.36 c1.965,2.77,3.826,5.615,5.891,8.312l12.149,16.358c16.494,21.585,33.949,42.449,52.7,62.138l0.004,0.004 c0.19,0.2,0.183,0.516-0.017,0.707c-0.198,0.189-0.512,0.182-0.702-0.013c-19.036-19.474-36.839-40.126-53.627-61.576 l-12.304-16.308c-2.091-2.689-3.978-5.525-5.969-8.287l-5.901-8.337c-1.957-2.786-3.956-5.544-5.88-8.353l-5.666-8.498 l-5.667-8.498l-2.833-4.25c-0.935-1.423-1.823-2.875-2.737-4.311l-10.869-17.296c-3.572-5.796-6.985-11.689-10.485-17.53 c-1.73-2.932-3.5-5.841-5.198-8.791l-5.027-8.89l-5.027-8.89l-2.513-4.445l-2.433-4.489l-9.693-17.978 c-3.187-6.015-6.255-12.093-9.389-18.136c-1.547-3.032-3.144-6.039-4.651-9.091l-4.51-9.161 c-2.974-6.123-6.06-12.193-8.911-18.374l-8.697-18.476l-8.417-18.604c-2.848-6.182-5.478-12.461-8.222-18.69l-4.076-9.36 l-3.952-9.413c-10.578-25.084-20.648-50.382-30.079-75.917c-9.45-25.526-18.489-51.206-26.879-77.098 c-4.181-12.951-8.242-25.939-12.142-38.977c-1.931-6.525-3.844-13.054-5.688-19.605l-2.71-9.842l-1.301-4.938 c-0.403-1.668-0.852-3.265-1.186-5.048c-0.051-0.269,0.127-0.529,0.396-0.58c0.266-0.05,0.522,0.123,0.577,0.386L237.133,602.736 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M2049.905,323.429c0.012-5.2-8.625-7.773-11.639-3.462 c-29.135,41.68-110.045,148.611-201.211,192.336c-148.438,71.193-274.603,217.808-221.852,325.626 C1615.203,837.929,2048.598,889.987,2049.905,323.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.43,
      fill: "#FFFFFF"
    },
    d: "M2019.628,385.957c-0.587,1.47-1.245,2.674-1.871,3.99l-1.961,3.835 c-1.334,2.54-2.659,5.086-4.027,7.608c-2.717,5.054-5.499,10.071-8.308,15.073c-5.614,10.008-11.455,19.883-17.336,29.736 c-11.882,19.633-24.31,38.933-37.165,57.946c-25.655,38.067-53.502,74.651-83.103,109.754 c-14.849,17.515-30.356,34.465-46.284,51.006l-12.116,12.242c-2,2.06-4.07,4.049-6.146,6.033l-6.208,5.969l-6.208,5.969 c-2.087,1.971-4.234,3.878-6.348,5.821c-4.256,3.854-8.457,7.771-12.776,11.553c-17.293,15.122-35.264,29.45-53.791,43.024 c-18.723,13.311-38.128,25.63-58.153,36.853c-0.241,0.135-0.545,0.049-0.68-0.192c-0.134-0.238-0.051-0.54,0.185-0.676 l0.007-0.004c19.815-11.511,38.946-24.132,57.423-37.653c18.348-13.697,36.13-28.137,53.23-43.362 c17.005-15.325,33.582-31.13,49.476-47.616c15.851-16.523,31.19-33.532,46.089-50.924c14.816-17.463,29.174-35.315,43.064-53.529 l10.33-13.727l10.127-13.878c6.684-9.301,13.333-18.628,19.809-28.078c12.993-18.87,25.498-38.076,37.584-57.543 c6.005-9.756,11.974-19.538,17.715-29.453c2.874-4.956,5.719-9.928,8.5-14.935c1.4-2.498,2.757-5.02,4.122-7.536l2.006-3.794 c0.629-1.261,1.338-2.581,1.847-3.762l0.055-0.127c0.108-0.251,0.399-0.366,0.65-0.258 C2019.611,385.426,2019.727,385.709,2019.628,385.957z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1690.752,168.075c-1.089-5.901-9.382-6.421-11.175-0.695 c-17.33,55.361-67.319,199.103-139.874,274.006c-118.136,121.96-200.341,323.274-130.214,430.908 C1409.488,872.294,1809.366,810.993,1690.752,168.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.43,
      fill: "#FFFFFF"
    },
    d: "M1676.845,247.397c-0.202,1.704-0.523,3.231-0.796,4.825l-0.91,4.725l-1.923,9.424 c-1.318,6.274-2.702,12.534-4.104,18.79c-2.839,12.503-5.834,24.969-8.943,37.408c-6.247,24.871-13.121,49.582-20.389,74.175 c-7.25,24.6-15.119,49.018-23.479,73.265l-3.121,9.098l-3.241,9.056c-2.186,6.028-4.262,12.097-6.55,18.088l-6.738,18.02 l-7.009,17.918c-2.29,5.991-4.809,11.891-7.217,17.835l-3.662,8.896c-1.224,2.964-2.536,5.891-3.8,8.839 c-2.565,5.879-5.067,11.785-7.684,17.641l-7.979,17.511l-2.004,4.373l-2.083,4.337l-4.165,8.674l-4.165,8.674 c-1.41,2.881-2.891,5.727-4.333,8.592c-2.923,5.711-5.76,11.466-8.752,17.14l-9.129,16.944c-0.769,1.407-1.513,2.829-2.302,4.225 l-2.397,4.173l-4.793,8.345l-4.793,8.344c-1.632,2.761-3.338,5.48-5.003,8.222l-5.024,8.208c-1.698,2.722-3.293,5.507-5.09,8.166 l-10.542,16.104c-14.436,21.218-29.88,41.749-46.555,61.249c-0.179,0.21-0.495,0.234-0.705,0.055 c-0.208-0.178-0.234-0.49-0.06-0.699l0.004-0.005c16.376-19.696,31.458-40.414,45.593-61.747l10.384-16.145 c1.771-2.665,3.341-5.457,5.012-8.185l4.945-8.226c1.639-2.747,3.317-5.471,4.923-8.238l4.714-8.361l4.713-8.361l2.357-4.18 c0.776-1.399,1.507-2.823,2.262-4.233l9.022-16.944c2.97-5.668,5.785-11.416,8.685-17.12c1.431-2.862,2.9-5.704,4.3-8.582 l4.133-8.664l4.133-8.664l2.066-4.332l1.988-4.369l7.915-17.492c2.596-5.85,5.077-11.751,7.621-17.624 c1.253-2.944,2.554-5.868,3.768-8.83l3.649-8.88c2.417-5.927,4.944-11.809,7.244-17.783 c18.988-47.562,35.573-96.067,50.54-145.052c7.446-24.506,14.423-49.157,20.916-73.936c3.258-12.387,6.401-24.804,9.391-37.258 c1.476-6.232,2.936-12.467,4.328-18.717l2.036-9.385l0.965-4.701c0.291-1.559,0.631-3.169,0.836-4.645l0.015-0.109 c0.038-0.271,0.288-0.461,0.56-0.423C1676.688,246.885,1676.876,247.13,1676.845,247.397z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M866.125,71.618c70.965,63.607,468.824,450.628,172.711,889.208 c0,0-327.514-187.364-185.998-884.832C854.076,69.892,861.489,67.463,866.125,71.618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.86,
      fill: "#FFFFFF"
    },
    d: "M884.796,165.648c12.918,27.576,25.257,55.398,37.358,83.33 c12.087,27.936,23.851,56.012,35.286,84.222s22.541,56.555,33.308,85.029c10.755,28.479,21.07,57.125,31.025,85.897 c19.799,57.576,37.941,115.77,52.865,174.847c7.554,29.511,14.043,59.308,19.385,89.32c5.296,30.013,9.419,60.289,11.114,90.794 c0.061,1.103-0.783,2.047-1.886,2.108c-1.103,0.061-2.047-0.783-2.108-1.886l0-0.006l0-0.009 c-1.587-30.29-5.593-60.442-10.775-90.36c-5.228-29.919-11.604-59.656-19.05-89.128 c-14.705-58.997-32.639-117.176-52.237-174.756c-9.854-28.775-20.07-57.429-30.727-85.921 c-10.669-28.487-21.678-56.849-33.018-85.079c-11.339-28.23-23.009-56.328-35.001-84.288 c-12.004-27.952-24.255-55.811-37.069-83.391l-0.003-0.007c-0.197-0.424-0.013-0.928,0.411-1.125 C884.096,165.042,884.599,165.224,884.796,165.648z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108270677717528002620000012293250107679263653_",
    gradientUnits: "userSpaceOnUse",
    x1: 1119.1868,
    y1: 1068.6058,
    x2: 1095.1866,
    y2: 1696.6068
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000108270677717528002620000012293250107679263653_)"
    },
    points: "980.629,1201.107  954.676,1433.868 1255.78,1433.868 1216.56,1201.107  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126317689535136058970000000690108741621808777_",
    gradientUnits: "userSpaceOnUse",
    x1: 1130.0601,
    y1: 337.6883,
    x2: 1026.0608,
    y2: 1213.6875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126317689535136058970000000690108741621808777_)"
    },
    d: "M349.019,512.284v640.309 c0,52.674,41.975,95.749,94.631,97.107c233.872,6.031,1051.844,20.654,1274.474,17.372c38.264-0.564,69.262-31.185,70.366-69.437 c4.293-148.752,11.265-506.452-14.536-672.519c-5.434-34.972-34.953-61.123-70.326-62.254 c-195.955-6.269-1063.059-26.174-1285.586-21.177C379.664,442.547,349.019,473.896,349.019,512.284z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017478361316543696860000012187204986104143271_",
    gradientUnits: "userSpaceOnUse",
    x1: 1004.6671,
    y1: 884.8878,
    x2: 1982.7648,
    y2: -93.2099
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#feb701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffde7e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017478361316543696860000012187204986104143271_)"
    },
    d: "M389.197,509.167v608.338 c0,30.754,24.687,55.813,55.438,56.273l1241.461,15.338c30.487,0.456,55.477-24.072,55.591-54.562l2.077-602.902 c0.081-21.801-17.288-39.664-39.082-40.194L433.655,465.778C409.278,465.185,389.197,484.784,389.197,509.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M1751.033,1213.325c-0.006,0-0.012,0-0.018,0L389.18,1190.121 c-0.552-0.01-0.992-0.465-0.983-1.018c0.01-0.553,0.437-0.974,1.017-0.982l1361.835,23.204c0.552,0.01,0.992,0.465,0.983,1.017 C1752.022,1212.889,1751.577,1213.325,1751.033,1213.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    d: "M1083.549,1241.664c-8.364,0-15.169-6.805-15.169-15.169s6.805-15.17,15.169-15.17 s15.169,6.806,15.169,15.17S1091.913,1241.664,1083.549,1241.664z M1083.549,1213.325c-7.262,0-13.169,5.908-13.169,13.17 s5.908,13.169,13.169,13.169s13.169-5.907,13.169-13.169S1090.811,1213.325,1083.549,1213.325z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066499268839079605930000005050227308824583342_",
    gradientUnits: "userSpaceOnUse",
    x1: 1176.4182,
    y1: 1198.9767,
    x2: 1112.4183,
    y2: 1422.9766
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066499268839079605930000005050227308824583342_)"
    },
    d: "M1320.637,1481.49H879.951 c-11.972,0-20.963-8.523-18.648-17.678l5.654-22.364c1.701-6.725,9.099-11.663,17.888-11.937l424.837-13.257 c9.181-0.286,17.31,4.587,19.311,11.577l10.194,35.62C1341.836,1472.707,1332.803,1481.49,1320.637,1481.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M1117.18,1435.134c-0.545,0-0.991-0.438-1-0.985c-0.008-0.553,0.433-1.007,0.985-1.015 l18.206-0.266c0.531,0.029,1.006,0.433,1.015,0.985c0.008,0.553-0.433,1.007-0.985,1.015l-18.206,0.266 C1117.19,1435.134,1117.186,1435.134,1117.18,1435.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M877.618,1468.725c-0.052,0-0.106-0.004-0.159-0.013c-0.545-0.087-0.917-0.6-0.83-1.145 l2.597-16.266c1.362-8.531,8.62-14.814,17.258-14.941l193.089-2.823c0.005,0,0.01,0,0.015,0c0.545,0,0.991,0.438,1,0.985 c0.008,0.553-0.433,1.007-0.985,1.015l-193.089,2.823c-7.664,0.112-14.104,5.688-15.313,13.256l-2.597,16.266 C878.526,1468.374,878.101,1468.725,877.618,1468.725z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067918537396873988570000005495909171130247869_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.3856,
    y1: 1298.2389,
    x2: 1608.5007,
    y2: 443.1548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067918537396873988570000005495909171130247869_)"
    },
    d: "M1652.075,519.522L465.668,504.915 c-18.695-0.23-33.9,15.066-34.167,34.193l-7.625,552.513c-0.263,18.882,14.32,34.511,32.766,35.164l1193.135,42.217 c16.598,0.587,32.151-5.748,44.096-17.554c11.945-11.806,18.125-28.069,18.125-45.061V582.169 C1712,547.861,1685.605,519.934,1652.075,519.522z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071552818360727382160000006470845137653883012_",
    gradientUnits: "userSpaceOnUse",
    x1: 1044.0361,
    y1: 292.0266,
    x2: 421.8312,
    y2: 1350.6603
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071552818360727382160000006470845137653883012_)"
    },
    d: "M470.35,533.763h531.868 c14.502,0,26.184,14.674,25.921,32.559l-7.483,508.984c-0.352,23.955-16.324,43.061-35.745,42.76l-515.134-7.974 c-14.196-0.22-25.609-14.483-25.6-31.996l0.247-512.373C444.433,548.069,456.038,533.763,470.35,533.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M478.762,548.773H989.48c13.925,0,25.143,14.063,24.89,31.206l-7.185,487.822 c-0.338,22.959-15.675,41.27-34.324,40.982l-494.649-7.642c-13.632-0.211-24.59-13.881-24.582-30.666l0.238-491.07 C453.876,562.484,465.019,548.773,478.762,548.773z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M830.378,606.723c-0.05,0-0.098,0-0.148,0l-337.276-3.762 c-8.729-0.097-15.832-6.984-15.833-15.352l-0.002-13.224c-0.001-3.246,1.319-6.293,3.717-8.582 c2.379-2.27,5.536-3.52,8.89-3.52h342.939c3.398,0,6.642,1.399,8.9,3.838c2.157,2.33,3.213,5.326,2.973,8.437l-1.62,20.988 C842.432,601.839,836.938,606.722,830.378,606.723z M489.726,565.283c-2.58,0-5.001,0.956-6.819,2.69 c-1.798,1.716-2.789,3.993-2.788,6.411l0.002,13.224c0.001,6.732,5.772,12.274,12.866,12.352l337.276,3.762 c5.088,0.045,9.295-3.637,9.663-8.408l1.62-20.988c0.175-2.268-0.6-4.458-2.183-6.168c-1.692-1.828-4.133-2.876-6.698-2.876 H489.726z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M826.262,600.47l-327.186-2.755c-7.713-0.065-13.919-4.588-13.92-10.146l-0.002-9.686 c-0.001-4.288,4.823-7.765,10.775-7.765h332.679c5.867,0,10.497,3.591,10.067,7.807l-1.571,15.372 C836.686,597.377,831.938,600.518,826.262,600.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M938.291,657.243H478.746c-3.049,0-5.52-2.724-5.52-6.085V634.88 c0-3.382,2.501-6.115,5.569-6.085l459.545,4.479c3.03,0.03,5.472,2.745,5.472,6.085v11.799 C943.811,654.519,941.34,657.243,938.291,657.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M974.662,768.087l-483.951-6.455c-8.605-0.115-15.52-7.123-15.52-15.729v-66.447 c0-8.85,7.225-15.998,16.074-15.904l482.544,5.161c9.517,0.102,17.179,7.846,17.179,17.363v65.901 C990.988,760.959,983.643,768.207,974.662,768.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M896.522,817.561H478.059c-2.776,0-5.027-2.724-5.027-6.085v-16.278 c0-3.382,2.278-6.115,5.071-6.085l418.463,4.479c2.759,0.03,4.982,2.745,4.982,6.085v11.799 C901.549,814.836,899.298,817.561,896.522,817.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M974.469,938.336l-483.951-7.068c-8.605-0.126-15.52-7.8-15.52-17.223v-72.76 c0-9.691,7.225-17.518,16.074-17.414l482.544,5.651c9.517,0.111,17.179,8.591,17.179,19.013v72.162 C990.795,930.531,983.45,938.467,974.469,938.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M986.866,990.541H480.103c-3.362,0-6.088-2.724-6.088-6.085v-16.278 c0-3.382,2.758-6.115,6.141-6.085l506.763,4.479c3.341,0.029,6.034,2.745,6.034,6.085v11.799 C992.953,987.817,990.228,990.541,986.866,990.541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M975.452,1096.318l-483.951-6.142c-8.605-0.109-15.52-6.778-15.52-14.966v-63.227 c0-8.421,7.225-15.223,16.074-15.133l482.544,4.911c9.517,0.097,17.178,7.465,17.178,16.522v62.707 C991.778,1089.536,984.433,1096.432,975.452,1096.318z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161590440709909111210000010724917429703161006_",
    gradientUnits: "userSpaceOnUse",
    x1: 1730.3035,
    y1: 442.6705,
    x2: 1618.3037,
    y2: 612.6703
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161590440709909111210000010724917429703161006_)"
    },
    d: "M1092.537,798.877h472.787 c12.891,0,23.276,13.157,23.042,29.195l-6.652,456.388c-0.313,21.48-14.51,38.611-43.569,38.342l-457.912-7.15 c-0.825-0.197-10.97-12.987-10.962-28.69l0.22-459.427C1069.5,811.704,1079.815,798.877,1092.537,798.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M1102.964,811.236h453.987c12.379,0,22.35,12.501,22.125,27.739l-6.387,433.634 c-0.301,20.409-13.933,36.686-30.511,36.43l-439.703-6.793c-12.118-0.187-21.859-12.339-21.851-27.259l0.211-436.521 C1080.842,823.424,1090.748,811.236,1102.964,811.236z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132805970265253405300000007661769826426898354_",
    gradientUnits: "userSpaceOnUse",
    x1: 1386.1206,
    y1: 747.507,
    x2: 1152.1202,
    y2: 1205.5072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132805970265253405300000007661769826426898354_)"
    },
    d: "M1578.387,885.739h-497.764v-48.596 c0-14.308,11.599-25.907,25.907-25.907h447.408c13.503,0,24.449,10.946,24.449,24.449V885.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M1522.935,853.978l-258.24-2.449c-6.088-0.058-10.986-4.079-10.987-9.019l-0.002-8.61 c-0.001-3.812,3.807-6.902,8.504-6.902h262.575c4.63,0,8.285,3.192,7.945,6.94l-1.24,13.664 C1531.163,851.228,1527.415,854.02,1522.935,853.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1555.514,930.263h-452.042c-2.999,0-5.43-2.422-5.43-5.409v-14.47 c0-3.006,2.461-5.436,5.478-5.409l452.042,3.982c2.98,0.026,5.382,2.44,5.382,5.409v10.488 C1560.944,927.841,1558.513,930.263,1555.514,930.263z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1211.502,852.001c-7.432,0-13.479-6.047-13.479-13.478c0-7.432,6.046-13.479,13.479-13.479 s13.479,6.047,13.479,13.479C1224.981,845.954,1218.935,852.001,1211.502,852.001z M1211.502,827.044 c-6.329,0-11.479,5.15-11.479,11.479s5.149,11.478,11.479,11.478s11.479-5.149,11.479-11.478 S1217.832,827.044,1211.502,827.044z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1168.313,853.013c-7.432,0-13.479-6.047-13.479-13.479c0-7.432,6.046-13.478,13.479-13.478 s13.479,6.047,13.479,13.478C1181.792,846.966,1175.746,853.013,1168.313,853.013z M1168.313,828.056 c-6.329,0-11.479,5.149-11.479,11.478s5.149,11.479,11.479,11.479s11.479-5.149,11.479-11.479 S1174.643,828.056,1168.313,828.056z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1126.813,853.013c-7.432,0-13.479-6.047-13.479-13.479c0-7.432,6.046-13.478,13.479-13.478 c7.432,0,13.478,6.047,13.478,13.478C1140.292,846.966,1134.245,853.013,1126.813,853.013z M1126.813,828.056 c-6.329,0-11.479,5.149-11.479,11.478s5.149,11.479,11.479,11.479s11.478-5.149,11.478-11.479 S1133.143,828.056,1126.813,828.056z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089534124438543650140000012567581439726289582_",
    gradientUnits: "userSpaceOnUse",
    x1: 1329.175,
    y1: 743.2891,
    x2: 1333.175,
    y2: 907.2887
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089534124438543650140000012567581439726289582_)"
    },
    d: "M1376.822,973.891l-84.545-0.703 c-2.649-0.022-4.778-2.187-4.756-4.836l0.02-2.358c0.021-2.587,2.091-4.691,4.677-4.755l84.568-2.092 c2.71-0.067,4.937,2.124,4.915,4.834l-0.043,5.153C1381.636,971.784,1379.471,973.913,1376.822,973.891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1395.043,1127.517l-124.473-1.035c-4.206-0.035-7.588-3.473-7.552-7.679l1.036-124.667 c0.034-4.13,3.354-7.479,7.483-7.552l122.916,2.332c5.206,0.099,9.361,4.371,9.316,9.577l-1.047,121.47 C1402.688,1124.17,1399.25,1127.552,1395.043,1127.517z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152961555183837779200000013254788024711407252_",
    gradientUnits: "userSpaceOnUse",
    x1: 1171.988,
    y1: 747.1226,
    x2: 1175.988,
    y2: 911.1221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152961555183837779200000013254788024711407252_)"
    },
    d: "M1219.542,973.891l-84.545-0.703 c-2.649-0.022-4.778-2.187-4.756-4.836l0.02-2.358c0.021-2.587,2.091-4.691,4.677-4.755l84.568-2.092 c2.71-0.067,4.937,2.124,4.915,4.834l-0.043,5.153C1224.355,971.784,1222.19,973.913,1219.542,973.891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1237.763,1127.517l-124.473-1.035c-4.206-0.035-7.587-3.473-7.552-7.679l1.036-124.667 c0.034-4.13,3.354-7.479,7.483-7.552l122.916,2.332c5.206,0.099,9.361,4.371,9.317,9.577l-1.047,121.47 C1245.407,1124.17,1241.969,1127.552,1237.763,1127.517z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031891590419350910520000015625626121656010900_",
    gradientUnits: "userSpaceOnUse",
    x1: 1486.7561,
    y1: 739.4463,
    x2: 1490.7561,
    y2: 903.4448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031891590419350910520000015625626121656010900_)"
    },
    d: "M1534.569,976.839l-84.545-0.703 c-2.649-0.022-4.778-2.187-4.756-4.836l0.02-2.358c0.021-2.587,2.091-4.691,4.677-4.755l84.568-2.092 c2.71-0.067,4.937,2.124,4.915,4.834l-0.043,5.153C1539.383,974.732,1537.218,976.862,1534.569,976.839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1552.79,1130.465l-124.473-1.035c-4.206-0.035-7.587-3.473-7.552-7.679l1.036-124.667 c0.034-4.13,3.353-7.479,7.483-7.552l122.916,2.332c5.206,0.099,9.361,4.371,9.317,9.577l-1.047,121.47 C1560.434,1127.119,1556.996,1130.5,1552.79,1130.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1558.502,1232.109c0,8.362-6.844,15.107-15.205,14.984l-432.273-6.339 c-7.2-0.106-12.981-5.974-12.981-13.175v-74.984c0-7.321,5.967-13.238,13.287-13.176l434.112,3.662 c7.097,0.06,12.871,5.73,13.061,12.824V1232.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1540.148,1298.97l-430.232-5.531c-6.583-0.085-11.874-5.445-11.874-12.028v-17.508 c0-4.492,3.673-8.117,8.165-8.058l443.341,5.84c6.319,0.083,11.397,5.229,11.397,11.548v5.206 C1560.944,1289.882,1551.59,1299.117,1540.148,1298.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M603.499,1531.48c-2.165,0-3.919-1.755-3.919-3.919v-468.455c0-2.165,1.755-3.919,3.919-3.919 c2.165,0,3.919,1.754,3.919,3.919v468.455C607.418,1529.725,605.663,1531.48,603.499,1531.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M497.292,1531.48c-2.165,0-3.919-1.755-3.919-3.919v-468.455c0-2.165,1.754-3.919,3.919-3.919 c2.165,0,3.919,1.754,3.919,3.919v468.455C501.211,1529.725,499.457,1531.48,497.292,1531.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M236.356,1534.451c-0.512,0-1.031-0.101-1.532-0.314c-1.992-0.847-2.92-3.148-2.074-5.141 l200.414-471.425c0.847-1.992,3.151-2.918,5.14-2.073c1.992,0.847,2.92,3.148,2.074,5.141l-200.414,471.425 C239.33,1533.556,237.88,1534.451,236.356,1534.451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M360.15,1534.451c-0.512,0-1.031-0.101-1.532-0.314c-1.992-0.847-2.92-3.148-2.074-5.141 l200.414-471.425c0.847-1.992,3.151-2.918,5.14-2.073c1.992,0.847,2.92,3.148,2.074,5.141l-200.414,471.425 C363.124,1533.556,361.674,1534.451,360.15,1534.451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M612.296,1063.417H423.287c-1.553,0-2.811-1.259-2.811-2.811v-5.425 c0-1.553,1.259-2.811,2.811-2.811h189.009c1.553,0,2.811,1.259,2.811,2.811v5.425 C615.107,1062.159,613.849,1063.417,612.296,1063.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M530.288,1135.109h-124.16c-2.165,0-3.919-1.755-3.919-3.919c0-2.165,1.755-3.919,3.919-3.919 h124.16c2.165,0,3.919,1.755,3.919,3.919C534.207,1133.355,532.452,1135.109,530.288,1135.109z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.031,
    y: 1216.43,
    style: {
      fill: "#a2be3d"
    },
    width: 124.16,
    height: 7.838
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.15,
    y: 1305.588,
    style: {
      fill: "#a2be3d"
    },
    width: 124.161,
    height: 7.838
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M416.633,1402.585h-124.16c-2.165,0-3.919-1.754-3.919-3.919s1.754-3.919,3.919-3.919h124.16 c2.165,0,3.919,1.754,3.919,3.919S418.798,1402.585,416.633,1402.585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M379.24,1491.745H255.08c-2.165,0-3.919-1.755-3.919-3.919c0-2.165,1.754-3.919,3.919-3.919 h124.16c2.165,0,3.919,1.754,3.919,3.919C383.159,1489.991,381.405,1491.745,379.24,1491.745z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072987153856665177190000003197733344782229407_",
    gradientUnits: "userSpaceOnUse",
    x1: 2685.6814,
    y1: 1751.3047,
    x2: 2730.3484,
    y2: 1607.9708,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072987153856665177190000003197733344782229407_)"
    },
    d: "M597.667,1049.261 c-9.769,0.845-26.723,2.216-40.089,2.804c-8.034,0.354-12.66-0.433-15.324-1.5c0.005,0.3,0.013,0.584,0.025,0.848 c0.063,1.406,1.206,2.531,2.627,2.611c25.255,1.41,45.341,0.488,52.492,0.053c1.479-0.09,2.36-1.697,1.604-2.958 C598.623,1050.49,598.165,1049.872,597.667,1049.261z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154419800029182304630000004674103774280727706_",
    gradientUnits: "userSpaceOnUse",
    x1: 542.2515,
    y1: 1040.844,
    x2: 597.6674,
    y2: 1040.844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154419800029182304630000004674103774280727706_)"
    },
    d: "M557.579,1052.066 c13.366-0.588,30.32-1.96,40.089-2.804c-9.604-11.783-40.089-19.725-40.089-19.725h-8.61 c-5.922,8.536-6.779,16.662-6.714,21.03C544.919,1051.633,549.544,1052.42,557.579,1052.066z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116232410170311165100000017803413749600270729_",
    gradientUnits: "userSpaceOnUse",
    x1: 2880.5193,
    y1: 1025.241,
    x2: 2896.5815,
    y2: 1025.241,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116232410170311165100000017803413749600270729_)"
    },
    d: "M547.519,1015.48l0.806,15.944 c0.087,1.726,1.38,3.177,3.109,3.425c1.721,0.246,4.024,0.278,6.468-0.536c1.503-0.5,2.619-1.767,2.896-3.311l2.784-15.521 H547.519z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047753647922515290740000016231666854754765727_",
    gradientUnits: "userSpaceOnUse",
    x1: 2565.3984,
    y1: 1713.8219,
    x2: 2610.0654,
    y2: 1570.4875,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047753647922515290740000016231666854754765727_)"
    },
    d: "M435.69,1051.946 c-4.236-0.591-6.153-2.791-6.956-5.144c-0.005,0.021-0.011,0.042-0.016,0.063c-0.623,2.482,0.822,5.054,3.71,6.277 c3.492,1.478,7.309,1.73,10.273,1.608c3.179-0.131,6.098-1.447,7.702-3.553l0.024-0.032 C447.235,1052.746,442.755,1052.932,435.69,1051.946z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057859276362771356340000012498710267968079273_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.734,
    y1: 1033.9645,
    x2: 460.8086,
    y2: 1033.9645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057859276362771356340000012498710267968079273_)"
    },
    d: "M455.664,1015.378h-7.1 c-10.815-0.221-17.607,22.59-19.83,31.424c0.803,2.353,2.72,4.553,6.956,5.144c7.065,0.986,11.545,0.8,14.737-0.78 c5.843-7.689,8.74-18.95,10.132-25.522C462.143,1018.17,455.664,1015.378,455.664,1015.378z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060709149431709793570000002910190966012274339_",
    gradientUnits: "userSpaceOnUse",
    x1: 2778.4058,
    y1: 1011.851,
    x2: 2797.6016,
    y2: 1011.851,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060709149431709793570000002910190966012274339_)"
    },
    d: "M449.476,1000.58l-3.943,15.681 c-0.484,1.923,0.437,3.911,2.214,4.824c2.206,1.132,5.311,2.321,8.165,1.977c1.342-0.162,2.457-1.107,2.901-2.371 l5.788-16.498L449.476,1000.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039104948190789279230000005446646515897977020_",
    gradientUnits: "userSpaceOnUse",
    x1: 444.7732,
    y1: 901.9224,
    x2: 596.3401,
    y2: 901.9224
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039104948190789279230000005446646515897977020_)"
    },
    d: "M444.773,1005.112 c4.905,4.351,20.861,4.926,20.861,4.926C523.107,872.097,546.618,852.5,546.618,852.5 c-8.299,52.065-1.338,167.332-1.338,167.332c9.484,4.185,21.712,0,21.712,0c0.77-85.238,13.872-159.573,29.349-218.178 c-38.845-0.873-59.502-14.166-66.247-19.501C497.712,834.356,444.773,1005.112,444.773,1005.112z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021815455401995190490000016318656305207057561_",
    gradientUnits: "userSpaceOnUse",
    x1: 607.8126,
    y1: 686.7213,
    x2: 397.8132,
    y2: 832.7209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#feb701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffde7e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021815455401995190490000016318656305207057561_)"
    },
    d: "M539.958,623.52 c-7.353,36.674-4.718,102.315-2.987,132.255c0.486,8.415-5.388,20.081-10.137,28.04c-0.745,1.248-0.285,2.847,1.008,3.511 c7.949,4.086,34.881,16.749,66.094,18.324c2.081,0.105,3.939-1.313,4.479-3.326c23.153-86.451,50.046-141.694,50.046-141.694 C618.771,613.218,539.958,623.52,539.958,623.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049942930125421801880000009669409287389844864_",
    gradientUnits: "userSpaceOnUse",
    x1: 571.8842,
    y1: 857.6376,
    x2: 641.8842,
    y2: 991.6378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049942930125421801880000009669409287389844864_)"
    },
    d: "M550.539,849.235 c-0.326,0-0.657-0.088-0.956-0.27c-0.867-0.53-1.142-1.661-0.615-2.527c0.309-0.509,7.744-12.525,22.788-19.783 c0.914-0.439,2.015-0.059,2.458,0.857c0.442,0.915,0.058,2.017-0.858,2.457c-14.025,6.768-21.173,18.268-21.244,18.383 C551.765,848.92,551.159,849.235,550.539,849.235z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036949330100109161440000017471889311158133654_",
    gradientUnits: "userSpaceOnUse",
    x1: 803.8266,
    y1: 1514.2675,
    x2: 900.4933,
    y2: 1478.2675,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036949330100109161440000017471889311158133654_)"
    },
    d: "M493.839,728.775 c2.362,17.085,9.339,35.72,23.298,55.515l5.306-4.326c0,0-6.126-24.852-2.643-53.057 C511.19,725.227,501.021,726.959,493.839,728.775z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000204510283574071100000001763307400312644495_",
    gradientUnits: "userSpaceOnUse",
    x1: 577.0241,
    y1: 642.4365,
    x2: 367.0239,
    y2: 788.4366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#feb701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffde7e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000204510283574071100000001763307400312644495_)"
    },
    d: "M548.17,668.772l-8.212-45.252 c0,0-54.87,41.942-46.119,105.255c7.181-1.816,17.351-3.548,25.961-1.868C522.309,706.589,529.802,684.532,548.17,668.772z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058581534296934210990000017764773483045307051_",
    gradientUnits: "userSpaceOnUse",
    x1: 631.9497,
    y1: 721.4391,
    x2: 421.95,
    y2: 867.439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#feb701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffde7e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058581534296934210990000017764773483045307051_)"
    },
    d: "M648.462,660.631l-21.179,45.613 c3.424,27.538,18.218,39.446,34.169,44.013c0.995-12.551,4.168-22.69,7.113-29.704 C648.183,699.51,648.462,660.631,648.462,660.631z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096761261410801319980000017368332400520202382_",
    gradientUnits: "userSpaceOnUse",
    x1: 2994.4509,
    y1: 737.7698,
    x2: 3048.2671,
    y2: 737.7698,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096761261410801319980000017368332400520202382_)"
    },
    d: "M668.564,720.553 c-2.945,7.014-6.118,17.154-7.113,29.704c42.557,16.511,53.816-15.51,53.816-15.51l-7.865-1.388 C689.641,735.23,677.234,729.504,668.564,720.553z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022550272975574862700000017999123519494440380_",
    gradientUnits: "userSpaceOnUse",
    x1: 2942.1409,
    y1: 593.9542,
    x2: 2941.553,
    y2: 694.4514,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022550272975574862700000017999123519494440380_)"
    },
    d: "M628.948,604.318l-10.225,37.588 c-1.149,4.223-5.716,6.49-9.779,4.866c-4.385-1.753-9.948-4.146-14.737-6.732c-5.112-2.76-6.712-9.336-3.476-14.161 l21.258-31.697L628.948,604.318z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127746607770275922510000011616945760186730151_",
    gradientUnits: "userSpaceOnUse",
    x1: 459.5599,
    y1: 777.1922,
    x2: 741.3703,
    y2: 777.1922
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127746607770275922510000011616945760186730151_)"
    },
    d: "M734.772,709.594l-262.005,95.359 c-10.989,4-16.241,16.512-11.4,27.157l0.795,1.748c4.283,9.418,15.415,13.549,24.805,9.205L741.37,725.374L734.772,709.594z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.23
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#d9e6ae"
    },
    cx: 855.2,
    cy: 652.232,
    rx: 129.338,
    ry: 127.005
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024698769226595785890000002543321329747175580_",
    gradientUnits: "userSpaceOnUse",
    x1: 711.2817,
    y1: 652.2324,
    x2: 999.1185,
    y2: 652.2324
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024698769226595785890000002543321329747175580_)"
    },
    d: "M855.2,510.91 c-79.484,0-143.919,63.272-143.919,141.322c0,78.051,64.434,141.322,143.919,141.322c79.484,0,143.918-63.272,143.918-141.322 C999.119,574.182,934.684,510.91,855.2,510.91z M855.2,772.794c-67.808,0-122.777-53.977-122.777-120.563 c0-66.585,54.969-120.562,122.777-120.562s122.777,53.978,122.777,120.562C977.977,718.817,923.008,772.794,855.2,772.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M722.224,669.272c-0.248,0-0.463-0.184-0.496-0.437c-0.425-3.333-0.726-6.73-0.892-10.097 c-0.014-0.276,0.199-0.511,0.475-0.524c0.285-0.027,0.511,0.199,0.525,0.475c0.165,3.341,0.463,6.712,0.885,10.019 c0.035,0.274-0.159,0.524-0.433,0.56C722.266,669.271,722.245,669.272,722.224,669.272z M723.212,629.755 c-0.029,0-0.059-0.002-0.089-0.008c-0.271-0.049-0.453-0.309-0.404-0.581c1.624-9.054,4.227-17.962,7.736-26.477 c9.938-24.108,26.773-44.661,48.687-59.438c22.436-15.129,48.736-23.126,76.058-23.126c25.695,0,50.674,7.138,72.237,20.643 c0.234,0.146,0.305,0.455,0.158,0.689c-0.147,0.235-0.455,0.306-0.689,0.158c-21.403-13.405-46.199-20.49-71.706-20.49 c-27.121,0-53.228,7.938-75.498,22.955c-21.749,14.665-38.458,35.064-48.32,58.987c0,0.001-0.001,0.002-0.001,0.003 c-3.483,8.449-6.066,17.288-7.677,26.273C723.66,629.585,723.45,629.755,723.212,629.755z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130646433486409569300000009739502133396999040_",
    gradientUnits: "userSpaceOnUse",
    x1: 816.6069,
    y1: 1548.5603,
    x2: 913.2734,
    y2: 1512.5603,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130646433486409569300000009739502133396999040_)"
    },
    d: "M520.256,779.211l24.768-2.018 l10.727,9.888c0,0-2.538,3.508-10.472,1.492c-7.934-2.016-18.802-2.511-18.802-2.511s-10.953,4.938-11.086-4.301 L520.256,779.211z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043455561167221663180000005521812783873642378_",
    gradientUnits: "userSpaceOnUse",
    x1: 778.3393,
    y1: 685.174,
    x2: 738.3392,
    y2: 717.174
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043455561167221663180000005521812783873642378_)"
    },
    d: "M712.112,740.606 c2.142,1.674,9.481-1.82,13.972-4.236c2.189-1.177,3.249-3.737,2.497-6.105c-1.081-3.408-2.882-7.807-5.1-8.362 C719.8,720.982,703.285,733.709,712.112,740.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M477.936,838.931c-0.054,0-0.109-0.009-0.164-0.027c-8.019-2.772-12.223-7.354-12.494-13.614 c-0.273-6.303,3.692-12.155,9.867-14.564l31.458-12.267c0.255-0.102,0.547,0.026,0.647,0.284 c0.1,0.257-0.027,0.547-0.284,0.647l-31.458,12.267c-5.776,2.253-9.486,7.714-9.231,13.589 c0.252,5.81,4.229,10.087,11.822,12.712c0.261,0.091,0.399,0.375,0.309,0.636C478.337,838.801,478.143,838.931,477.936,838.931 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M516.479,795.644c-0.2,0-0.389-0.121-0.466-0.318c-0.101-0.257,0.027-0.547,0.284-0.647 l4.077-1.59c0.257-0.103,0.547,0.026,0.648,0.284c0.1,0.257-0.027,0.547-0.284,0.647l-4.077,1.59 C516.602,795.634,516.54,795.644,516.479,795.644z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125565384508134366680000007650080896047610276_",
    gradientUnits: "userSpaceOnUse",
    x1: 632.9318,
    y1: 584.5298,
    x2: 584.5505,
    y2: 621.5489
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125565384508134366680000007650080896047610276_)"
    },
    d: "M631.158,567.417 c0,0,8.463,19.441,9.031,29.645c0.569,10.204,2.767,16.826-9.031,18.88c-11.799,2.055-21.738-3.823-27.123-13.987 c0,0-8.437-15.662-6.544-22.076C599.383,573.465,631.158,567.417,631.158,567.417z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038388224383017474670000006220322309229123519_",
    gradientUnits: "userSpaceOnUse",
    x1: 582.0298,
    y1: 575.8259,
    x2: 642.1231,
    y2: 575.8259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038388224383017474670000006220322309229123519_)"
    },
    d: "M608.067,594.648h1.491 c0,0-6.146-12.606-0.746-14.82c5.4-2.215,26.79-6.577,31.405-14.167c4.449-7.317,0.481-16.768-5.455-19.413 c-0.376-0.168-0.818,0.009-1.01,0.373l-0.492,0.93c-0.337,0.637-1.278,0.541-1.478-0.151l0,0 c-0.19-0.656-1.075-0.8-1.436-0.22c-1.413,2.269-5.238,5.96-15.498,7.854c-14.558,2.687-24.182,8.579-24.419,18.64 c-0.015,0.638-0.696,0.989-1.241,0.657c-1.075-0.655-2.795-0.962-5.093,0.971c-3.997,3.361-2.362,12.08,6.401,19.252 c0.416,0.341,0.413,0.991-0.038,1.285c-1.589,1.034-3.956,3.495,2.18,6.775c6.277,3.355,9.991,2.99,11.393,2.631 c0.377-0.096,0.631-0.44,0.607-0.829l-0.551-8.916c-0.029-0.461,0.338-0.851,0.8-0.851H608.067z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059997323875895030310000000294955396310851743_",
    gradientUnits: "userSpaceOnUse",
    x1: 626.9304,
    y1: 576.6868,
    x2: 578.5496,
    y2: 613.7055
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059997323875895030310000000294955396310851743_)"
    },
    d: "M608.433,596.513 c0,0-3.229-12.419-8.797-8.937c-5.568,3.482,2.889,13.915,7.365,14.38L608.433,596.513z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055702013023308214270000018304012642398878111_",
    gradientUnits: "userSpaceOnUse",
    x1: 960.8698,
    y1: 667.1622,
    x2: 1154.9237,
    y2: 667.1622
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#feb701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffde7e"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000055702013023308214270000018304012642398878111_)"
    },
    points: "776.664,630.385  825.635,668.503 919.651,591.442 943.907,619.138 825.635,742.882 749.854,659.877  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039844073310450519740000016512177063570040969_",
    gradientUnits: "userSpaceOnUse",
    x1: 2263.7095,
    y1: 319.2719,
    x2: 2177.7097,
    y2: 433.2718
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039844073310450519740000016512177063570040969_)"
    },
    d: "M1655.252,558.707h472.787 c12.891,0,23.275,13.157,23.042,29.195l-6.652,456.388c-0.313,21.479-14.51,38.611-43.569,38.342l-457.912-7.15 c-0.825-0.197-10.97-12.987-10.962-28.69l0.22-459.427C1632.214,571.535,1642.53,558.707,1655.252,558.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M1665.678,571.066h453.987c12.378,0,22.35,12.501,22.125,27.739l-6.387,433.634 c-0.301,20.409-13.934,36.686-30.511,36.43l-439.703-6.793c-12.117-0.187-21.859-12.339-21.851-27.259l0.211-436.521 C1643.557,583.255,1653.462,571.066,1665.678,571.066z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M2109.972,726.398l-432.658-3.541c-5.647-0.046-10.2-4.637-10.2-10.284v-31.971 c0-5.761,4.67-10.432,10.431-10.432h429.879c7.562,0,13.692,6.13,13.692,13.692v31.481 C2121.117,721.484,2116.113,726.448,2109.972,726.398z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115504597092301172800000003738002213441375894_",
    gradientUnits: "userSpaceOnUse",
    x1: 1887.692,
    y1: 654.3196,
    x2: 1869.692,
    y2: 768.3195
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115504597092301172800000003738002213441375894_)"
    },
    d: "M2141.102,657.853h-497.764V595.36 c0-13.417,10.876-24.293,24.293-24.293h451.486c12.142,0,21.984,9.843,21.984,21.984V657.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M2107.938,621.671l-227.805-2.16c-5.37-0.051-9.691-3.598-9.692-7.956l-0.001-7.595 c-0.001-3.362,3.358-6.089,7.502-6.089h231.629c4.085,0,7.309,2.816,7.009,6.122l-1.094,12.054 C2115.196,619.245,2111.89,621.709,2107.938,621.671z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164503939574428452400000015764414614154300838_",
    gradientUnits: "userSpaceOnUse",
    x1: 1733.8619,
    y1: 696.4847,
    x2: 2026.7384,
    y2: 696.4847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5fae5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e5f0d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164503939574428452400000015764414614154300838_)"
    },
    d: "M2023.303,709.129h-286.005 c-1.897,0-3.436-2.422-3.436-5.409v-14.47c0-3.006,1.557-5.436,3.466-5.409l286.005,3.982c1.886,0.026,3.405,2.44,3.405,5.409 v10.488C2026.738,706.707,2025.2,709.129,2023.303,709.129z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 91.2847 1432.8121)",
    style: {
      fill: "#a2be3d"
    },
    cx: 1775.2,
    cy: 606.216,
    rx: 12.478,
    ry: 12.478
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098920589998246717780000012907345506027910785_",
    gradientUnits: "userSpaceOnUse",
    x1: 1745.6572,
    y1: 569.2732,
    x2: 1703.7225,
    y2: 685.9039
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#feb701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffde7e"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000098920589998246717780000012907345506027910785_)"
    },
    cx: 1732.011,
    cy: 607.227,
    r: 12.478
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026162257523985972080000002911042702736316810_",
    gradientUnits: "userSpaceOnUse",
    x1: 1788.516,
    y1: 439.2178,
    x2: 1753.5161,
    y2: 499.2177
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000026162257523985972080000002911042702736316810_)"
    },
    cx: 1690.51,
    cy: 607.227,
    r: 12.478
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1889.072,888.079l-207.959-1.728c-7.027-0.058-12.695-3.515-12.66-7.721l1.036-124.666 c0.034-4.13,5.561-7.461,12.459-7.51l205.365,3.017c8.698,0.128,15.664,4.423,15.618,9.629l-1.072,121.47 C1901.824,884.775,1896.099,888.137,1889.072,888.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M2100.188,889.649l-171.762-1.428c-5.804-0.048-10.481-3.497-10.446-7.703l1.036-124.666 c0.034-4.13,4.604-7.469,10.301-7.528l169.618,2.72c7.184,0.115,12.931,4.4,12.886,9.607l-1.061,121.47 C2110.726,886.326,2105.992,889.697,2100.188,889.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M2103.648,1031.064c-0.032,7.994-6.552,14.441-14.546,14.383l-401.46-2.932 c-6.701-0.151-12.081-8.446-12.081-18.627V917.878c0-10.35,5.553-18.715,12.366-18.628l404,5.177 c6.605,0.085,11.979,8.101,12.155,18.131L2103.648,1031.064z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082333805602204708290000006887353981802243999_",
    gradientUnits: "userSpaceOnUse",
    x1: 2118.8469,
    y1: 595.1829,
    x2: 2062.8467,
    y2: 652.1829
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082333805602204708290000006887353981802243999_)"
    },
    d: "M2001.401,716.856 c3.846-0.482,7.245-2.181,9.883-4.667l16.532,16.281c0.945,0.901,2.443,0.861,3.339-0.09l0.166-0.176 c1.012-1.075,0.893-2.784-0.257-3.709l-18.199-14c3.049-3.724,4.628-8.68,3.976-13.882 c-1.248-9.955-10.184-17.032-19.959-15.807c-9.775,1.225-16.688,10.289-15.441,20.244 C1982.689,711.004,1991.625,718.081,2001.401,716.856z M1986.176,700.456c-0.914-7.292,4.15-13.931,11.31-14.829 c7.161-0.897,13.706,4.286,14.62,11.578c0.914,7.292-4.15,13.931-11.31,14.829 C1993.636,712.932,1987.09,707.748,1986.176,700.456z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070111730973018840170000009619943649492847254_",
    gradientUnits: "userSpaceOnUse",
    x1: 1691.9049,
    y1: 917.2703,
    x2: 2089.0164,
    y2: 917.2703
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5fae5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e5f0d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070111730973018840170000009619943649492847254_)"
    },
    d: "M2084.915,925.365l-389.065-3.986 c-2.19-0.022-3.95-0.7-3.945-1.518l0.061-9.222c0.006-0.83,1.825-1.489,4.048-1.465l389.064,4.22 c2.188,0.024,3.944,0.701,3.938,1.518l-0.06,8.987C2088.951,924.73,2087.135,925.388,2084.915,925.365z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176022689070147244510000018308482420987538860_",
    gradientUnits: "userSpaceOnUse",
    x1: 1690.7738,
    y1: 939.534,
    x2: 2087.8853,
    y2: 939.534
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5fae5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e5f0d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176022689070147244510000018308482420987538860_)"
    },
    d: "M2083.784,947.629l-389.065-3.986 c-2.19-0.022-3.95-0.7-3.945-1.518l0.061-9.222c0.005-0.83,1.825-1.489,4.048-1.465l389.063,4.22 c2.188,0.024,3.944,0.701,3.939,1.518l-0.06,8.987C2087.82,946.994,2086.004,947.652,2083.784,947.629z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112610342410080342540000012411889139398861464_",
    gradientUnits: "userSpaceOnUse",
    x1: 1690.6255,
    y1: 961.8043,
    x2: 2087.7368,
    y2: 961.8043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5fae5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e5f0d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112610342410080342540000012411889139398861464_)"
    },
    d: "M2083.635,969.899l-389.065-3.985 c-2.19-0.023-3.95-0.7-3.945-1.518l0.061-9.222c0.005-0.83,1.825-1.489,4.048-1.464l389.064,4.22 c2.188,0.024,3.944,0.701,3.938,1.518l-0.06,8.987C2087.671,969.264,2085.856,969.922,2083.635,969.899z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025422688127499002350000005926830911214400151_",
    gradientUnits: "userSpaceOnUse",
    x1: 1690.6255,
    y1: 984.0745,
    x2: 2087.7368,
    y2: 984.0745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5fae5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e5f0d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025422688127499002350000005926830911214400151_)"
    },
    d: "M2083.635,992.169l-389.065-3.985 c-2.19-0.022-3.95-0.7-3.945-1.518l0.061-9.222c0.005-0.83,1.825-1.489,4.048-1.465l389.064,4.22 c2.188,0.024,3.944,0.701,3.938,1.518l-0.06,8.987C2087.671,991.534,2085.856,992.192,2083.635,992.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016787722317455067220000009162778659267459212_",
    gradientUnits: "userSpaceOnUse",
    x1: 1690.6255,
    y1: 1005.9756,
    x2: 2087.7368,
    y2: 1005.9756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5fae5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e5f0d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016787722317455067220000009162778659267459212_)"
    },
    d: "M2083.635,1014.071l-389.065-3.986 c-2.19-0.022-3.95-0.7-3.945-1.518l0.061-9.222c0.005-0.83,1.825-1.489,4.048-1.464l389.064,4.22 c2.188,0.024,3.944,0.701,3.938,1.518l-0.06,8.987C2087.671,1013.435,2085.856,1014.093,2083.635,1014.071z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090263562545408617500000008413543343550829208_",
    gradientUnits: "userSpaceOnUse",
    x1: 1690.6254,
    y1: 1028.0148,
    x2: 1907.5366,
    y2: 1028.0148
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5fae5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e5f0d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090263562545408617500000008413543343550829208_)"
    },
    d: "M1905.265,1035.522l-212.489-2.809 c-1.196-0.016-2.156-0.688-2.15-1.506l0.061-9.222c0.005-0.83,1.001-1.494,2.215-1.477l212.488,3.044 c1.195,0.017,2.152,0.688,2.147,1.506l-0.06,8.987C1907.471,1034.874,1906.478,1035.538,1905.265,1035.522z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169521713779921226830000014288100813888299660_",
    gradientUnits: "userSpaceOnUse",
    x1: 1483.0754,
    y1: 103.3274,
    x2: 1111.1553,
    y2: 995.0575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169521713779921226830000014288100813888299660_)"
    },
    d: "M1091.507,225.603h472.787 c12.891,0,23.276,13.157,23.042,29.195l-6.652,456.388c-0.313,21.48-14.51,38.611-43.569,38.341l-440.141-6.872 c-15.293-0.239-28.106-12.22-28.705-27.504c-0.019-0.485-0.029-0.973-0.028-1.463l0.22-459.427 C1068.469,238.431,1078.785,225.603,1091.507,225.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M1101.933,237.963h453.987c12.379,0,22.35,12.501,22.126,27.739l-6.387,433.634 c-0.301,20.409-13.933,36.686-30.511,36.43l-439.703-6.793c-12.117-0.187-21.859-12.339-21.851-27.259l0.211-436.521 C1079.812,250.151,1089.717,237.963,1101.933,237.963z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178181499517292199350000009282103844990852773_",
    gradientUnits: "userSpaceOnUse",
    x1: 1384.754,
    y1: 11.6968,
    x2: 1264.7424,
    y2: 602.755
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178181499517292199350000009282103844990852773_)"
    },
    d: "M1535.91,325.653h-420.661 c-3.597,0-6.513-2.916-6.513-6.513v-27.958c0-3.774,3.059-6.833,6.833-6.833h419.186c3.682,0,6.667,2.985,6.667,6.667v29.125 C1541.422,323.185,1538.954,325.653,1535.91,325.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M1506.392,313.085h-158.582c-2.614,0.983-4.734-1.364-4.734-4.259v-7.769 c0-2.895,2.12-5.242,4.734-5.242h158.582c2.614,0,4.734,2.347,4.734,5.242v7.769 C1511.125,311.721,1509.006,314.068,1506.392,313.085z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048491169966714533220000007274567194162968474_",
    gradientUnits: "userSpaceOnUse",
    x1: 1364.9426,
    y1: 367.5292,
    x2: 1118.9426,
    y2: 601.5292
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048491169966714533220000007274567194162968474_)"
    },
    d: "M1419.721,530.933 c0,10.875-8.804,19.697-19.679,19.72l-276.176,0.569c-7.218,0-13.07-5.985-13.07-13.368V391.133 c0-7.465,5.976-13.483,13.273-13.367l282.785,4.498c7.138,0.114,12.867,6.065,12.867,13.367V530.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1384.367,711.545l-118.166-0.982c-3.993-0.033-7.203-3.297-7.17-7.29l0.984-118.35 c0.033-3.92,3.184-7.1,7.104-7.169l116.688,2.214c4.942,0.094,8.887,4.149,8.844,9.092l-0.994,115.316 C1391.624,708.368,1388.36,711.578,1384.367,711.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1234.073,711.545l-118.166-0.982c-3.993-0.033-7.203-3.297-7.17-7.29l0.984-118.35 c0.033-3.92,3.184-7.1,7.104-7.169l116.688,2.214c4.942,0.094,8.887,4.149,8.844,9.092l-0.994,115.316 C1241.329,708.368,1238.066,711.578,1234.073,711.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1533.139,714.344l-118.166-0.982c-3.993-0.033-7.203-3.297-7.17-7.29l0.984-118.35 c0.033-3.92,3.184-7.1,7.104-7.169l116.688,2.214c4.942,0.094,8.887,4.149,8.844,9.092l-0.994,115.316 C1540.395,711.167,1537.131,714.378,1533.139,714.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9e6ae"
    },
    d: "M1531.488,557.819h-85.436c-5.487,0-9.934-4.477-9.934-10.001V391.716 c0-4.64,3.607-8.409,8.072-8.434l87.731-0.494c5.313,0.234,9.501,4.638,9.501,9.991v155.04 C1541.422,553.342,1536.975,557.819,1531.488,557.819z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150082678699020751570000000902472842452732853_",
    gradientUnits: "userSpaceOnUse",
    x1: 1194.4854,
    y1: 261.5459,
    x2: 1221.4419,
    y2: 261.5459
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5fae5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e5f0d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150082678699020751570000000902472842452732853_)"
    },
    d: "M1207.964,275.024 c-7.432,0-13.479-6.046-13.479-13.479s6.046-13.479,13.479-13.479c7.432,0,13.478,6.046,13.478,13.479 S1215.396,275.024,1207.964,275.024z M1207.964,250.067c-6.329,0-11.479,5.149-11.479,11.479s5.149,11.479,11.479,11.479 s11.478-5.149,11.478-11.479S1214.293,250.067,1207.964,250.067z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063614587925355492970000013668266176121077930_",
    gradientUnits: "userSpaceOnUse",
    x1: 1151.2964,
    y1: 262.5579,
    x2: 1178.2534,
    y2: 262.5579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5fae5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e5f0d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063614587925355492970000013668266176121077930_)"
    },
    d: "M1164.775,276.036 c-7.432,0-13.479-6.046-13.479-13.479c0-7.432,6.046-13.478,13.479-13.478s13.479,6.046,13.479,13.478 C1178.253,269.99,1172.207,276.036,1164.775,276.036z M1164.775,251.08c-6.329,0-11.479,5.149-11.479,11.478 s5.149,11.479,11.479,11.479s11.479-5.149,11.479-11.479S1171.104,251.08,1164.775,251.08z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073688811946235923900000000416276197844881814_",
    gradientUnits: "userSpaceOnUse",
    x1: 1109.7964,
    y1: 262.5579,
    x2: 1136.7529,
    y2: 262.5579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5fae5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e5f0d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073688811946235923900000000416276197844881814_)"
    },
    d: "M1123.274,276.036 c-7.432,0-13.478-6.046-13.478-13.479c0-7.432,6.046-13.478,13.478-13.478c7.432,0,13.479,6.046,13.479,13.478 C1136.753,269.99,1130.707,276.036,1123.274,276.036z M1123.274,251.08c-6.329,0-11.478,5.149-11.478,11.478 s5.149,11.479,11.478,11.479s11.479-5.149,11.479-11.479S1129.604,251.08,1123.274,251.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021820194492660516450000014025798260856318654_",
    gradientUnits: "userSpaceOnUse",
    x1: 1238.3743,
    y1: 460.2523,
    x2: 1304.9559,
    y2: 460.2523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5fae5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e5f0d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021820194492660516450000014025798260856318654_)"
    },
    d: "M1271.683,493.543 c-18.382,0-33.308-14.926-33.308-33.273c0-18.382,14.926-33.309,33.273-33.309c18.382,0,33.309,14.927,33.309,33.273v0.035 C1304.956,478.617,1290.029,493.543,1271.683,493.543z M1271.683,428.927c-17.298,0-31.343,14.045-31.343,31.308 c0,17.298,14.045,31.343,31.307,31.343c17.299,0,31.343-14.044,31.343-31.307v-0.035 C1302.99,442.972,1288.946,428.927,1271.683,428.927z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019646608250631506700000014754860039305508738_",
    gradientUnits: "userSpaceOnUse",
    x1: 1259.9767,
    y1: 460.013,
    x2: 1294.5602,
    y2: 460.013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5fae5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e5f0d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019646608250631506700000014754860039305508738_)"
    },
    d: "M1262.487,476.973 c-0.93,0-1.697-0.741-1.722-1.677l-0.787-29.391c-0.026-0.969,0.443-1.865,1.253-2.396c0.81-0.531,1.818-0.604,2.697-0.193 l29.033,13.579c0.958,0.448,1.571,1.383,1.599,2.441c0.028,1.057-0.535,2.024-1.468,2.522l-25.628,13.662 c-0.841,0.448-1.884,0.129-2.331-0.71c-0.448-0.84-0.13-1.883,0.71-2.331l24.443-13.031l-26.832-12.55l0.758,28.304 c0.025,0.952-0.725,1.743-1.677,1.769C1262.518,476.973,1262.502,476.973,1262.487,476.973z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101100566650509955120000001582256410174735239_",
    gradientUnits: "userSpaceOnUse",
    x1: 1129.4425,
    y1: 860.8527,
    x2: 1045.4424,
    y2: 974.8527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101100566650509955120000001582256410174735239_)"
    },
    d: "M794.181,1139.714 c32.728,75.287,119.399,115.535,177.41,114.918l15.801-24.39c-55.797-19.034-94.359-36.313-115.915-91.296 c-1.169-2.981-4.035-4.954-7.237-4.954h-66.286C795.009,1133.992,793.007,1137.013,794.181,1139.714z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039827835352141599490000014358150122337754251_",
    gradientUnits: "userSpaceOnUse",
    x1: 1220.1138,
    y1: 927.6624,
    x2: 1136.1136,
    y2: 1041.6624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039827835352141599490000014358150122337754251_)"
    },
    d: "M951.521,1290.206l75.42-43.984 c1.547-0.902,1.615-3.113,0.125-4.108l-51.058-34.116c-1.998-1.335-4.718-0.372-5.431,1.922l-23.782,76.527 C945.918,1289.269,948.968,1291.695,951.521,1290.206z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004536413334135617430000009167478572105371068_",
    gradientUnits: "userSpaceOnUse",
    x1: 1197.4097,
    y1: 98.2436,
    x2: 1115.4144,
    y2: 190.2382,
    gradientTransform: "matrix(0.9988 0.0499 -0.0499 0.9988 -21.9398 -48.9819)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004536413334135617430000009167478572105371068_)"
    },
    d: "M807.992,421.825 c36.337-73.613,124.857-109.615,182.77-106.188l14.6,25.127c-56.654,16.309-96.008,31.699-120.201,85.573 c-1.312,2.921-4.27,4.753-7.469,4.598l-66.208-3.211C808.542,427.58,806.689,424.466,807.992,421.825z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097468953924912916550000012434879103331855253_",
    gradientUnits: "userSpaceOnUse",
    x1: 1213.3267,
    y1: 112.4316,
    x2: 1131.3306,
    y2: 204.427,
    gradientTransform: "matrix(0.9988 0.0499 -0.0499 0.9988 -21.9398 -48.9819)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097468953924912916550000012434879103331855253_)"
    },
    d: "M972.438,279.132l82.145,25.085 c5.637,1.721,6.856,9.157,2.063,12.588l-63.733,45.625c-2.06,1.237-4.73,0.143-5.331-2.183l-20.047-77.589 C966.796,279.797,969.96,277.522,972.438,279.132z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047029795789185216550000006136194842503887488_",
    gradientUnits: "userSpaceOnUse",
    x1: 1867.1833,
    y1: 212.3622,
    x2: 1787.1863,
    y2: 274.36,
    gradientTransform: "matrix(0.9979 -0.0648 0.0648 0.9979 31.4099 116.0015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047029795789185216550000006136194842503887488_)"
    },
    d: "M1631.163,313.466 c81.773-7.247,158.559,49.636,185.75,100.884l-13.869,25.538c-43.393-39.908-77.005-65.517-135.602-58.164 c-3.177,0.399-6.281-1.176-7.811-3.988l-31.69-58.22C1626.533,316.929,1628.229,313.726,1631.163,313.466z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092447190441458725220000008701511780322045605_",
    gradientUnits: "userSpaceOnUse",
    x1: 1941.0435,
    y1: 307.6537,
    x2: 1861.0433,
    y2: 369.6539,
    gradientTransform: "matrix(0.9979 -0.0648 0.0648 0.9979 31.4099 116.0015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092447190441458725220000008701511780322045605_)"
    },
    d: "M1838.563,379.714l21.295,83.209 c1.461,5.71-4.256,10.618-9.679,8.309l-72.115-30.708c-2.128-1.117-2.582-3.966-0.908-5.689l55.845-57.474 C1835.061,375.242,1838.65,376.76,1838.563,379.714z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124160800506001085530000013513190428296466834_",
    gradientUnits: "userSpaceOnUse",
    x1: -123.2093,
    y1: 2355.2988,
    x2: 50.794,
    y2: 2109.2939,
    gradientTransform: "matrix(0.3506 -0.9365 0.9365 0.3506 834.9316 2191.8142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124160800506001085530000013513190428296466834_)"
    },
    d: "M1524.823,1152.397 c81.983-4.255,150.063-71.314,169.824-125.859l-17.302-23.349c-37.389,45.582-67.091,75.638-126.14,76.549 c-3.202,0.049-6.055,2.042-7.177,5.041l-23.24,62.079C1519.755,1149.616,1521.882,1152.55,1524.823,1152.397z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165953983179215553110000003842877924800715146_",
    gradientUnits: "userSpaceOnUse",
    x1: -30.5976,
    y1: 2420.8206,
    x2: 143.407,
    y2: 2174.8137,
    gradientTransform: "matrix(0.3506 -0.9365 0.9365 0.3506 834.9316 2191.8142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165953983179215553110000003842877924800715146_)"
    },
    d: "M1720.926,1057.807l-14.75-86.053 c-0.303-1.765-2.349-2.604-3.803-1.558l-49.852,35.856c-1.951,1.403-2.003,4.288-0.104,5.76l63.331,49.103 C1718.084,1062.726,1721.426,1060.72,1720.926,1057.807z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2110.439,
    y: 1339.231,
    style: {
      fill: "#a2be3d"
    },
    width: 12.848,
    height: 138.939
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M2173.126,1480.848H2060.6v-5.508c0-1.577,1.279-2.855,2.855-2.855h106.593 c1.7,0,3.078,1.378,3.078,3.078V1480.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M2194.406,1334.106c0,8.076-6.607,14.683-14.683,14.683H2058.73 c-8.076,0-14.684-6.608-14.684-14.683v-13.277c0-8.076,6.608-14.683,14.684-14.683h120.992c8.076,0,14.683,6.608,14.683,14.683 V1334.106z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097461746224461107850000000643368946868262583_",
    gradientUnits: "userSpaceOnUse",
    x1: 2014.2451,
    y1: 1472.4508,
    x2: 2061.9392,
    y2: 1472.4508
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097461746224461107850000000643368946868262583_)"
    },
    d: "M2045.305,1453.556 c0,0-36.687,26.444-30.317,44.21c0,0,40.14-17.319,44.99-30.961c4.849-13.642-0.82-19.668-0.82-19.668L2045.305,1453.556z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069379766092597138830000011212886223898370475_",
    gradientUnits: "userSpaceOnUse",
    x1: -104.6559,
    y1: 1444.6523,
    x2: -82.0628,
    y2: 1444.6523,
    gradientTransform: "matrix(-1 0 0 1 1952.506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069379766092597138830000011212886223898370475_)"
    },
    d: "M2050.818,1431.394l5.999,17.342 c0.905,2.617,0,5.597-2.341,7.076c-1.172,0.741-2.775,1.426-4.964,1.922c-3.09,0.701-6.28-0.727-7.766-3.525l-7.176-13.512 L2050.818,1431.394z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181774914507606594700000011010794044546696338_",
    gradientUnits: "userSpaceOnUse",
    x1: 2038.6726,
    y1: 1251.2959,
    x2: 2084.6726,
    y2: 1437.2954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181774914507606594700000011010794044546696338_)"
    },
    d: "M2109.196,1275.3 c0,0-75.353,13.06-107.677,42.92c-32.324,29.86,29.669,125.11,29.669,125.11s10.157-0.063,22.465-10.613 c0,0-36.757-71.636-5.079-92.527c35.614-23.486,76.656-28.776,76.656-28.776l-15.305-33.812L2109.196,1275.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054959152008593085450000002652132913957946017_",
    gradientUnits: "userSpaceOnUse",
    x1: 2061.3511,
    y1: 1381.5225,
    x2: 2057.3511,
    y2: 1399.5225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054959152008593085450000002652132913957946017_)"
    },
    d: "M2021.362,1487.939 c8.069-3.736,30.913-19.724,34.764-20.43c3.851-0.705,10.53,3.82,10.53,3.82s1.624,2.922-0.113,8.018 c-5.362,6.488-17.267,18.856-33.272,23.464c-11.773,3.39-20.008,0.23-25.136-3.468 C2010.957,1495.046,2015.989,1490.427,2021.362,1487.939z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055705528559977428690000005228965916945532348_",
    gradientUnits: "userSpaceOnUse",
    x1: -114.0378,
    y1: 1494.2665,
    x2: -53.286,
    y2: 1494.2665,
    gradientTransform: "matrix(-1 0 0 1 1952.506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#149cb4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67a7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055705528559977428690000005228965916945532348_)"
    },
    d: "M2033.271,1502.812 c16.005-4.609,27.91-16.976,33.272-23.464c-1.175,3.444-3.882,7.879-9.668,13.08c-14.35,12.897-41.757,17.546-47.592,16.65 c-4.676-0.718-4.235-5.034-1.149-9.735C2013.264,1503.042,2021.498,1506.202,2033.271,1502.812z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150788240222300636850000007517880341834297753_",
    gradientUnits: "userSpaceOnUse",
    x1: -120.9934,
    y1: 1465.5022,
    x2: -99.7892,
    y2: 1465.5022,
    gradientTransform: "matrix(-1 0 0 1 1952.506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150788240222300636850000007517880341834297753_)"
    },
    d: "M2073.5,1460.042 c-0.091,2.223-4.635,9.847-7.29,14.125c-1.262,2.033-3.473,3.275-5.866,3.281c-1.518,0.004-3.262-0.128-4.846-0.583 c-2.378-0.683-3.714-3.216-3.018-5.591l5.189-17.719L2073.5,1460.042z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168105477390678694250000001076480417497299862_",
    gradientUnits: "userSpaceOnUse",
    x1: 2309.0005,
    y1: 1419.9729,
    x2: 2191.0007,
    y2: 1380.9729
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168105477390678694250000001076480417497299862_)"
    },
    d: "M2181.73,1252.681 c0,0,16.735,44.747,0,58.355c-16.735,13.608-56.656,28.928-65.575,56.032c-8.918,27.104-24.052,79.779-44.305,98.434 c0,0-14.23-1.379-19.555-7.048c0,0,11.535-78.636,19.142-98.813c6.588-17.473,16.295-42.694,34.897-56.791 c5.325-4.035,4.397-10.427,1.928-16.635l-4.496-11.305L2181.73,1252.681z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086681398514466097000000004202354479285049731_",
    gradientUnits: "userSpaceOnUse",
    x1: 2060.3101,
    y1: 1107.2412,
    x2: 2046.9768,
    y2: 1168.5746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#feb701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#feb701"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086681398514466097000000004202354479285049731_)"
    },
    d: "M2007.197,1217.609 c28.059,1.692,19.316-43.136,18.81-44.919l42.587,30.081c0,0-2.255,23.973-37.662,36.548 c-8.958,3.181-17.146,3.322-24.384,1.766C2009.634,1232.083,2009.007,1224.005,2007.197,1217.609z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083806746406761650790000005691549141646624403_",
    gradientUnits: "userSpaceOnUse",
    x1: -56.2024,
    y1: 1220.9845,
    x2: 17.7648,
    y2: 1220.9845,
    gradientTransform: "matrix(-1 0 0 1 1952.506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083806746406761650790000005691549141646624403_)"
    },
    d: "M1952.941,1204.117 c10.456-7.273,22.302,0,22.302,0c13.98,9.143,24.324,13.032,31.954,13.492c1.81,6.396,2.438,14.473-0.649,23.475 c-15.662-3.367-26.867-14.702-31.736-20.518c-1.753-2.094-4.857-2.458-7-0.766c-2.177,1.719-4.292,4.073-3.908,6.551 c0.756,4.886-4.914,6.439-5.341,4.668c-0.427-1.772,1.94-12.277,1.94-12.277s-11.34,11.403-15.766,15.785 c-4.427,4.382-9.993,0-9.993,0S1942.485,1211.39,1952.941,1204.117z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019666561611043381330000011813383924733415086_",
    gradientUnits: "userSpaceOnUse",
    x1: 2160.8372,
    y1: 1123.5437,
    x2: 1996.8376,
    y2: 1348.5432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#feb701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffde7e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019666561611043381330000011813383924733415086_)"
    },
    d: "M2138.033,1103.461 c0,0-40.822-16.345-116.792,46.375c0,0-6.346,13.135,0.577,24.826c6.922,11.691,72.882,68.656,81.948,100.247 c0,0,39.296,12.769,79.935-17.51C2183.702,1257.4,2180.115,1169.479,2138.033,1103.461z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027596625533375529310000005314929197677324473_",
    gradientUnits: "userSpaceOnUse",
    x1: -126.7779,
    y1: 1111.8228,
    x2: -77.7015,
    y2: 1111.8228,
    gradientTransform: "matrix(-1 0 0 1 1952.506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027596625533375529310000005314929197677324473_)"
    },
    d: "M2057.334,1088.875l20.095,24.361 c1.995,2.419,2.435,5.783,1.055,8.599c-2.789,5.69-9.407,13.973-24.085,12.828c-4.366-0.341-8.233-2.975-10.14-6.918 l-14.051-29.047L2057.334,1088.875z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034053912361665617590000012163635725687359910_",
    gradientUnits: "userSpaceOnUse",
    x1: 2191.5774,
    y1: 1145.9498,
    x2: 2027.5774,
    y2: 1370.9497
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#feb701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffde7e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034053912361665617590000012163635725687359910_)"
    },
    d: "M2169.638,1207.797 c4.739-19.3-43.262-62.327-43.262-62.327l11.657-42.009c0,0,103.649,69,77.235,124.488c-3.787,7.954-8.816,13.526-14.646,17.253 C2192.276,1222.736,2178.976,1212.434,2169.638,1207.797z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147919594589433394170000013495424507713866930_",
    gradientUnits: "userSpaceOnUse",
    x1: 2193.0684,
    y1: 1132.9041,
    x2: 2095.7349,
    y2: 1218.9042
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#feb701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#feb701"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147919594589433394170000013495424507713866930_)"
    },
    d: "M2169.672,1204.987 c0.509,0,0.973-0.346,1.1-0.864c4.846-19.733-41.626-61.665-43.607-63.441c-0.465-0.417-1.181-0.38-1.602,0.087 c-0.418,0.467-0.378,1.184,0.087,1.602c0.475,0.425,47.443,42.79,42.918,61.212c-0.149,0.608,0.223,1.222,0.831,1.371 C2169.49,1204.977,2169.582,1204.987,2169.672,1204.987z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168112524273088760280000013287433437315684799_",
    gradientUnits: "userSpaceOnUse",
    x1: 2186.9038,
    y1: 1143.108,
    x2: 2141.9038,
    y2: 1214.108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168112524273088760280000013287433437315684799_)"
    },
    d: "M2096.935,1206.136 c0,0,56.911,22.095,70.802,5.476c0.942-1.127,1.556-2.411,1.901-3.815c9.338,4.636,22.638,14.939,30.985,37.405 c-29.932,19.126-81.094-10.64-94.928-19.416c-2.276-1.444-5.006-1.95-7.644-1.403c-5.336,1.107-14.553,2.733-19.524,1.968 c-7.273-1.12-17.719,24.533-29.506,16.62C2049.02,1242.972,2059.114,1198.381,2096.935,1206.136z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122708052864045936960000002111081931488056984_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.9472,
    y1: -543.1653,
    x2: 141.5961,
    y2: -462.0028,
    gradientTransform: "matrix(-0.9683 -0.2499 -0.2499 0.9683 2085.9526 1633.1084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122708052864045936960000002111081931488056984_)"
    },
    d: "M2013.608,1053.092 c-0.202,0.783,4.71,54.036,4.71,54.036l30.347-3.451l2.843-51.165C2051.508,1052.512,2016.992,1039.98,2013.608,1053.092z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160159189497337396060000014034414573017185423_",
    gradientUnits: "userSpaceOnUse",
    x1: 2001.2084,
    y1: 1076.8044,
    x2: 2071.1274,
    y2: 1076.8044
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160159189497337396060000014034414573017185423_)"
    },
    d: "M2043.604,1063.116l0.613,27.052 c0.008,0.347-0.03,0.685-0.116,1.021c-0.528,2.057-2.864,9.002-9.823,6.179c-6.315-2.562-12.116-4.805-16.382-3.996 c-1.915,0.364-3.24,2.118-3.06,4.059c0.448,4.838,1.658,15.722,4.152,25.018c0.506,1.886,2.383,3.054,4.306,2.715 c5.796-1.021,17.959-3.516,27.274-7.816c1.262-0.583,2.109-1.793,2.202-3.18c0.455-6.762,1.913-27.31,3.205-32.973 c1.213-5.315,8.174-7.815,11.171-8.656c0.983-0.276,1.802-0.936,2.281-1.838c1.695-3.185,4.374-10.693-4.994-14.917 c-1.96-0.884-2.792-3.194-1.848-5.127c1.878-3.848,3.156-9.894-3.989-14.086c-7.263-4.261-13.414-0.816-16.858,2.155 c-1.392,1.201-3.413,1.186-4.851,0.04c-0.819-0.652-1.932-0.959-3.395-0.256c-1.971,0.947-4.329-0.104-5.067-2.163 c-1.417-3.955-4.704-8.386-12.322-7.926c-13.519,0.816-16.635,15.356-14.081,24.356c2.555,9.001,17.161,7.283,24.785,3.723 c5.797-2.706,12.465,1.529,15.329,3.715C2043.045,1060.907,2043.578,1061.975,2043.604,1063.116z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019677758030963434030000016944052679311633808_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.0924,
    y1: -478.8904,
    x2: 162.3004,
    y2: -529.3765,
    gradientTransform: "matrix(-0.9683 -0.2499 -0.2499 0.9683 2085.9526 1633.1084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffde7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3cc75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019677758030963434030000016944052679311633808_)"
    },
    d: "M2056.101,1091.047 c0,0-3.778-15.874,2.237-19c6.015-3.126,14.103-0.273,11.061,10.593C2065.614,1096.155,2056.101,1091.047,2056.101,1091.047z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160872423795354294480000004471335942641782195_",
    gradientUnits: "userSpaceOnUse",
    x1: 1942.7577,
    y1: 1244.3043,
    x2: 2072.8545,
    y2: 1244.3043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160872423795354294480000004471335942641782195_)"
    },
    d: "M2067.779,1249.708 c-0.091,0.005-0.183,0.007-0.275,0.006l-119.407-0.13c-2.952-0.002-5.342-2.398-5.339-5.35c0.003-2.953,2.407-5.392,5.351-5.339 l119.407,0.13c2.952,0.003,5.342,2.398,5.339,5.35C2072.851,1247.235,2070.603,1249.568,2067.779,1249.708z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078738665896748345560000001218575827290658482_",
    gradientUnits: "userSpaceOnUse",
    x1: 1832.8059,
    y1: 1195.469,
    x2: 2003.3127,
    y2: 1195.469
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#032020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#217a83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078738665896748345560000001218575827290658482_)"
    },
    d: "M1840.755,1141.294h99.443 c7.336,0,14.013,4.234,17.142,10.869l45.972,97.482h-123.581c-4.727,0-8.975-2.888-10.713-7.285l-35.65-90.205 C1831.31,1146.942,1835.151,1141.294,1840.755,1141.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M1910.814,1191.276c2.155,6.695,0.563,13.197-3.556,14.523c-4.119,1.326-9.205-3.027-11.36-9.722 c-2.155-6.695-0.563-13.197,3.556-14.523C1903.573,1180.228,1908.659,1184.581,1910.814,1191.276z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M1856.877,1505.813c-0.661,0-1.333-0.128-1.98-0.397c-2.546-1.06-3.722-3.918-2.626-6.382 l105.235-236.842c1.094-2.464,4.044-3.601,6.592-2.543c2.546,1.06,3.722,3.918,2.626,6.382l-105.235,236.842 C1860.672,1504.712,1858.822,1505.813,1856.877,1505.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M1975.429,1505.813c-1.945,0-3.795-1.101-4.612-2.94l-105.235-236.842 c-1.095-2.464,0.081-5.322,2.626-6.382c2.544-1.06,5.496,0.078,6.592,2.543l105.235,236.842 c1.095,2.464-0.081,5.322-2.626,6.382C1976.764,1505.685,1976.091,1505.813,1975.429,1505.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M2182.626,1505.813c-0.662,0-1.333-0.128-1.98-0.397c-2.546-1.06-3.722-3.918-2.626-6.382 l105.235-236.842c1.095-2.464,4.043-3.601,6.592-2.543c2.546,1.06,3.722,3.918,2.626,6.382l-105.235,236.842 C2186.421,1504.712,2184.571,1505.813,2182.626,1505.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M2301.177,1505.813c-1.945,0-3.795-1.101-4.612-2.94l-105.236-236.842 c-1.095-2.464,0.081-5.322,2.626-6.382c2.544-1.06,5.496,0.078,6.593,2.543l105.235,236.842 c1.095,2.464-0.081,5.322-2.626,6.382C2302.512,1505.685,2301.839,1505.813,2301.177,1505.813z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2be3d"
    },
    d: "M2313.521,1254.881c0.268-1.553-0.097-3.16-0.997-4.38c-0.899-1.221-2.239-1.927-3.652-1.927 h-478.744c-1.859,0-3.589,1.061-4.59,2.814s-1.135,3.956-0.356,5.845l5.188,12.571c1.188,2.879,3.762,4.722,6.595,4.722h468.624 c2.635,0,4.899-2.092,5.4-4.988L2313.521,1254.881z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebTour);
export default __webpack_public_path__ + "static/media/web-tour.bfef69d19b82b09c0e8748e1f1ba45e3.svg";
export { ForwardRef as ReactComponent };